import React from 'react';
import ReactDOM from 'react-dom';
import ReactDOMServer from 'react-dom/server';

import * as d3 from 'd3';
import * as Constants from "./Constants.js";

import {
  Badge,
  Button,
  Card,
  CardBody,
  CardText,
  Collapse,
  Spinner,
  Container, 
  Row, 
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Table,
  Input,
  FormGroup
} from 'reactstrap';

import axios from 'axios';

import { 
  FaHome, 
  FaDownload, 
  FaRegCircle, 
  FaRegDotCircle, 
  FaChevronCircleDown, 
  FaChevronCircleUp, 
  FaSearch,
  FaRegEye,
  FaCog,
  FaInfoCircle,
  FaCaretRight
} from 'react-icons/fa'

// ref. https://react-bootstrap-table.github.io/react-bootstrap-table2/storybook
// ref. https://github.com/react-bootstrap-table/react-bootstrap-table2/tree/master/docs
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import BootstrapTable from 'react-bootstrap-table-next';

import ReactTooltip from 'react-tooltip';

import InfiniteScroll from "react-infinite-scroll-component";

import SequenceLogo from './seqlogo';

import Loader from 'react-loader-spinner';
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";

import {
  DebounceInput
} from 'react-debounce-input';

import CryptoJS from 'crypto-js';

const queryString = require('query-string');

class ViewPanelV3 extends React.Component {

  constructor(props) {
    super(props);
    this.state = { 
      clientWidth: -1,
      clientHeight: -1,
      clientMargin: 12,
      clientPadding: 12,
      navbarHeight: 0,
      openClose: {
        discoveredMotifs: true,
        jobSummary: true,
        motifDetails: true,
        motifConsensusSequence: true,
        motifSites: true,
        motifLocations: true,
        motifLocationSites: true,
        downloads: false,
        epilogosMEMEDownloads: true,
        analysisDownloads: true,
      },
      visible: {
        motifLocations: true,
      },
      currentMotifIdx: -1,
      sitesInfiniteTableData: [],
      sitesInfiniteTableDataOffsets: [],
      sitesInfiniteTableDataInitialChunk: 50,
      sitesInfiniteTableDataChunk: 250,
      sitesInfiniteTableHasMoreData: [],
      sitesKeys: [],
      locationsKey: 0,
      currentLocationSelection: "viewMotifLocations",
      locationsInfiniteTableData: [],
      locationsInfiniteTableDataOffset: 0,
      locationsInfiniteTableDataInitialChunk: 50,
      locationsInfiniteTableDataChunk: 250,
      locationsInfiniteTableHasMoreData: true,
      locationsAllLocations: 0,
      locationsMotifAndScannedLocations: 0,
      locationsMotifLocations: 0,
      noaxisSeqlogoHTMLs: [],
      motifColors: [],
      motifColorsOffset: 6,
      viewerContainerKey: 0,
      fimoQueryButtonStates: [],
      fimoQueryModalIsOpen: false,
      fimoQueryMotifIdx: -1,
      fimoQueryMotifItem: "",
      fimoQueryMotifGenome: "",
      fimoQueryMotifStateModel: "",
      fimoQueryMotifSample: "",
      fimoQueryMotifBackground: Constants.epilogosFimoQueryMotifDefaultBackground,
      fimoQueryMotifPvalueThreshold: Constants.epilogosFimoQueryMotifDefaultPvalueThreshold,
      fimoQueryMotifMEMEVersion: "",
      fimoQueryMotifResultsDirectory: "",
      fimoQueryMotifEmail: "",
      fimoQueryMotifFailureMessage: "",
      fimoQueryMotifDataAvailable: [],
      fimoQueryMotifDataModalIsOpen: false,
      fimoQueryMotifData: [],
      fimoReadyButtonIsDisabled: [],
      fimoHitsButtonIsDisabled: [],
      fimoQueryMotifSampleSimples: [],
      fimoSimpleButtonIsDisabled: [],
      fimoSimpleSampleIsDisabled: [],
      epilogoDownloadOptionIsOpen: []
    }
    this.downloadResultsButton = React.createRef();
    this.downloadJSONButton = React.createRef();
    this.downloadItemButton = React.createRef();
    this.locationTooltipRef = React.createRef();
    this.fimoBackgroundRef = React.createRef();
    this.fimoManifestCheckTimerIDs = [];
  }
  
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }
  
  componentDidMount() {
    let self = this;
    window.addEventListener("resize", this.updateDimensions);
    //console.log("this.props.jobMetadata", JSON.stringify(this.props.jobMetadata, null, 2));
    //console.log("this.props.fimoManifest", JSON.stringify(this.props.fimoManifest, null, 2));
    setTimeout(() => {
      this.updateDimensions();
      this.initializeFimoQueryButtonStates();
      this.initializeMotifColors();
      this.initializeSitesInfiniteTableData();
      this.initializeLocationsInfiniteTableData();
      setTimeout(() => {
        let newFimoQueryMotifDataAvailable = [];
        let newFimoQueryMotifData = [];
        let newFimoManifestCheckTimerIDs = [];
        let newFimoReadyButtonIsDisabled = [];
        let newFimoHitsButtonIsDisabled = [];
        let newFimoSimpleButtonIsDisabled = [];
        let newFimoSimpleSampleIsDisabled = [];
        let newNoaxisSeqlogoElements = [];
        let newEpilogoDownloadOptionIsOpen = [];
        this.props.memeMotifs.attributes.forEach((a, ai) => {
          newFimoQueryMotifDataAvailable[ai] = false;
          newFimoManifestCheckTimerIDs.push(null);
          newFimoQueryMotifData.push(null);
          newFimoReadyButtonIsDisabled.push(false);
          newFimoHitsButtonIsDisabled.push(false);
          newFimoSimpleButtonIsDisabled.push(false);
          newFimoSimpleSampleIsDisabled.push(false);
          newEpilogoDownloadOptionIsOpen.push(false);
          const noaxisSeqlogoId = `#logo-${ai}-noaxis`;
          //console.log(`looking for ${noaxisSeqlogoId}...`);
          //const seqlogoElement = document.getElementById(noaxisSeqlogoId);
          const noaxisSeqlogoElement = d3.select(noaxisSeqlogoId);
          if (noaxisSeqlogoElement) {
            newNoaxisSeqlogoElements[ai] = noaxisSeqlogoElement;
          }
        });
        if (this.props.fimoManifest) {
          const jobKeys = Object.keys(this.props.fimoManifest.jobs);
          jobKeys.forEach((jk, ji) => {
            const job = this.props.fimoManifest.jobs[jk];
            //const jobIdx = job.epilogoIdx;
            //const jobIdx = ji;
            const jobIdxRegex = /Epilogo (?<idx>[0-9]+)/;
            const jobIdx = parseInt(job.epilogoName.match(jobIdxRegex).groups.idx) - 1;
            const jobName = job.epilogoName;
            const jobStatus = job.status;
            //console.log(`${jk} | ${JSON.stringify(jobIdx, null, 2)} | ${jobName} | ${jobStatus}`);
            if (jobStatus === "finished") {
              newFimoQueryMotifData[jobIdx] = this.cloneObject(this.props.fimoManifest);
              newFimoQueryMotifDataAvailable[jobIdx] = true;
            }           
          });
        }
        this.setState({
          fimoQueryMotifDataAvailable: newFimoQueryMotifDataAvailable,
          fimoQueryMotifData: newFimoQueryMotifData,
          fimoReadyButtonIsDisabled: newFimoReadyButtonIsDisabled,
          fimoHitsButtonIsDisabled: newFimoHitsButtonIsDisabled,
          fimoSimpleButtonIsDisabled: newFimoSimpleButtonIsDisabled,
          fimoSimpleSampleIsDisabled: newFimoSimpleSampleIsDisabled,
          noaxisSeqlogoElements: newNoaxisSeqlogoElements,
          epilogoDownloadOptionIsOpen: newEpilogoDownloadOptionIsOpen
        }, () => {
          //console.log("this.state.fimoQueryMotifData", JSON.stringify(this.state.fimoQueryMotifData, null, 2));
          //console.log("self.state.noaxisSeqlogoElements", self.state.noaxisSeqlogoElements);
          let newNoaxisSeqlogoHTMLs = [];
          this.state.noaxisSeqlogoElements.forEach((e, ei) => {
            //console.log(`noaxisSeqlogoElement as HTML ${ei} ${e.html()}`);
            newNoaxisSeqlogoHTMLs[ei] = e.html();
          });
          this.setState({
            noaxisSeqlogoHTMLs: newNoaxisSeqlogoHTMLs
          });
        });
        this.fimoManifestCheckTimerIDs = newFimoManifestCheckTimerIDs;
      }, 0);
    }, 0);
  }
  
  componentDidUpdate() {
    if (!window.location) return;
    let hash = window.location.hash.replace('#', '');
    if (hash) {
      let node = ReactDOM.findDOMNode(this.refs[hash]);
      if (node) {
        node.scrollIntoView();
      }
    }
  }
  
  shouldComponentUpdate(nextProps, nextState) {
    //console.log("shouldComponentUpdate", nextState);
    return true;
  }
  
  updateDimensions = () => {
    const windowInnerHeight = document.documentElement.clientHeight + "px";
    const windowInnerWidth = document.documentElement.clientWidth + "px";
    const seqlogoWidth = (windowInnerWidth) ? Math.min(parseInt(windowInnerWidth)/3, 400) : 400;
    this.setState({
      clientWidth: windowInnerWidth,
      clientHeight: windowInnerHeight,
      seqlogoWidth: seqlogoWidth,
      motifKey: Math.random()
    }, () => {
      
    });
  }

  initializeMotifColors = () => {
    function byte2Hex(n) {
      var nybHexString = "0123456789ABCDEF";
      return String(nybHexString.substr((n >> 4) & 0x0F,1)) + nybHexString.substr(n & 0x0F,1);
    }
    function RGB2Color(r,g,b) {
      return '#' + byte2Hex(r) + byte2Hex(g) + byte2Hex(b);
    }
    function makeColorGradient(frequency1, frequency2, frequency3,
                               phase1, phase2, phase3,
                               center, width, len) {
      if (center == undefined)   center = 128;
      if (width == undefined)    width = 127;
      if (len == undefined)      len = 50;
      let results = [];
      for (let i = 0; i < len; ++i)
      {
         const red = Math.sin(frequency1*i + phase1) * width + center;
         const grn = Math.sin(frequency2*i + phase2) * width + center;
         const blu = Math.sin(frequency3*i + phase3) * width + center;
         results.push(RGB2Color(red,grn,blu));
      }
      return results;
    }
    const center = 128;
    const width = 127;
    const frequency = 2.4;
    const colors = makeColorGradient(frequency, frequency, frequency, 0, 2, 4, center, width, 50);
    this.setState({
      motifColors: colors
    });
  }
  
  changeCurrentMotifIdx = (i) => {
    if (i === this.state.currentMotifIdx) return;
    this.setState({
      currentMotifIdx: i
    });
  }
  
  downloadBlobAsFile = (blob, fileName) => {
    var a = document.createElement("a");
    var objectURL = URL.createObjectURL(blob);
    a.href = objectURL;
    a.style.display = "none";
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    setTimeout(function(){
      document.body.removeChild(a);
      window.URL.revokeObjectURL(objectURL);  
    }, 100);
  }
  
  handleClick = (event, customObj) => {
    //console.log("handleClick", event, event.target.name, event.target.dataset, customObj);
    document.activeElement.blur();
    event.preventDefault();
    event.stopPropagation();
    //var targetAttr = event.target.target;
    var name = (event.target) ? (event.target.name || customObj.name) : '';
    var self = this;
    if (name === 'downloadResults') {
      axios.get(this.props.archiveURL, { responseType: 'blob' })
        .then(function(response) {
          let id = self.props.uuid;
          let fn = "epilogos-search." + id + ".tbz2";
          self.downloadBlobAsFile(new Blob([response.data], {type: "application/bzip2"}), fn);
        })
        .catch(function(error) {
          console.log(error);
        })
    }
    else if (name === 'downloadJSONEpilogosMEME') {
      let blob = new Blob([JSON.stringify(this.props.memeJSON)], {type: "application/json"});
      let url = window.URL.createObjectURL(blob);
      this.downloadURI(url, "meme.json");
      window.URL.revokeObjectURL(url);
    }
    else if (name === 'downloadJSONAnalysis') {
      let blob = new Blob([JSON.stringify(this.props.jobMetadata)], {type: "application/json"});
      let url = window.URL.createObjectURL(blob);
      this.downloadURI(url, "analysis.json");
      window.URL.revokeObjectURL(url);
    }
    else if ((name === 'downloadSVG') || (event.target.dataset.id === 'SVG')) {
      //console.log("event.target.dataset.idx", event.target.dataset.idx);
      const idx = event.target.dataset.idx; //this.state.currentMotifIdx;
      const name = this.props.memeMotifs.attributes[idx].name;
      const alt = this.props.memeMotifs.attributes[idx].alt;
      const svg = document.getElementById(`logo-${idx}-${name}`);
      const serializer = new XMLSerializer();
      let source = serializer.serializeToString(svg);
      source = '<?xml version="1.0" standalone="no"?>\r\n' + source;
      let blob = new Blob([source], {type: "image/svg+xml"});
      let url = window.URL.createObjectURL(blob);
      this.downloadURI(url, `${alt}.${name}.svg`);
      setTimeout(function() {
        window.URL.revokeObjectURL(url);
      }, 1000);
    }
    else if (name === "downloadEpilogosItem") {
      const idx = event.target.dataset.idx;
      const name = event.target.dataset.id;
      const item = this.props.memeMotifs.items[idx];
      const model = this.props.memeMotifs.model;
      const assembly = this.props.memeMotifs.assembly;
      const modifiedItem = this.substituteAlphabet(item, model, assembly);
      let blob = new Blob([modifiedItem], {type: "application/text"});
      let url = window.URL.createObjectURL(blob);
      this.downloadURI(url, `${name}.meme.txt`);
      window.URL.revokeObjectURL(url);
    }
    else if ((name === "downloadEpilogoFimoMotifAllHits") || (name === "downloadEpilogoFimoMotifTop100Hits") || (name === "viewEpilogoFimoMotifTop100Hits")) {
      let id = event.target.dataset.id;
      let idx = event.target.dataset.idx;
      let path = event.target.dataset.path;
      let type = event.target.dataset.type;
      let epilogoName = event.target.dataset.epilogoname;
      let extension = event.target.dataset.extension;
      let sample = event.target.dataset.sample;
      let genome = event.target.dataset.genome;
      let backgroundModel = event.target.dataset.backgroundmodel;
      let pValueThreshold = parseFloat(event.target.dataset.pvaluethreshold).toExponential();
      let stateModel = event.target.dataset.statemodel;
      
      if (!id && customObj && customObj.id) id = customObj.id;
      if (!idx && customObj && customObj.idx) idx = customObj.idx;
      if (!path && customObj && customObj.path) path = customObj.path;
      if (!type && customObj && customObj.type) type = customObj.type;
      if (!epilogoName && customObj && customObj.epilogoName) epilogoName = customObj.epilogoName;
      if (!extension && customObj && customObj.extension) extension = customObj.extension;
      if (!sample && customObj && customObj.sample) sample = customObj.sample;
      if (!genome && customObj && customObj.genome) genome = customObj.genome;
      if (!backgroundModel && customObj && customObj.backgroundModel) backgroundModel = customObj.backgroundModel;
      if (!pValueThreshold && customObj && customObj.pValueThreshold) pValueThreshold = parseFloat(customObj.pValueThreshold).toExponential();
      if (!stateModel && customObj && customObj.stateModel) stateModel = customObj.stateModel;
      
      function parseUrl(url) {
        var m = url.match(/^(([^:\/?#]+:)?(?:\/\/((?:([^\/?#:]*):([^\/?#:]*)@)?([^\/?#:]*)(?::([^\/?#:]*))?)))?([^?#]*)(\?[^#]*)?(#.*)?$/),
            r = {
                hash: m[10] || "",                   // #asd
                host: m[3] || "",                    // localhost:257
                hostname: m[6] || "",                // localhost
                href: m[0] || "",                    // http://username:password@localhost:257/deploy/?asd=asd#asd
                origin: m[1] || "",                  // http://username:password@localhost:257
                pathname: m[8] || (m[1] ? "/" : ""), // /deploy/
                port: m[7] || "",                    // 257
                protocol: m[2] || "",                // http:
                search: m[9] || "",                  // ?asd=asd
                username: m[4] || "",                // username
                password: m[5] || ""                 // password
            };
        if (r.protocol.length == 2) {
          r.protocol = "file:///" + r.protocol.toUpperCase();
          r.origin = r.protocol + "//" + r.host;
        }
        r.href = r.origin + r.pathname + r.search + r.hash;
        return m && r;
      };
      
      let parsedArchiveURL = parseUrl(this.props.archiveURL);
      let parsedArchiveURLBits = parsedArchiveURL.pathname.split('/');
      let parsedArchiveURLBitsWeWant = parsedArchiveURLBits.slice(1, parsedArchiveURLBits.length - 1);
      
      let pathBits = path.split('/');
      let pathBitsWeWant = pathBits.slice(pathBits.length - 3, pathBits.length);
      
      //console.log("this.props.archiveURL", this.props.archiveURL);
      //console.log("parsedArchiveURLBitsWeWant", parsedArchiveURLBitsWeWant);
      
      //console.log("path", path);
      //console.log("pathBitsWeWant", pathBitsWeWant);
      
      let combinedPathBits = [...parsedArchiveURLBitsWeWant, ...pathBitsWeWant];
      
      let newArchiveURL = `${parsedArchiveURL.protocol}//${parsedArchiveURL.host}/${combinedPathBits.join('/')}`;
      //console.log("newArchiveURL", newArchiveURL);
      
      if (type === "viewTop100Hits") {
        axios.get(newArchiveURL)
          .then(function(response) {
            //console.log("response.data", response.data);
            let firstLineOfTopHits = response.data.toString().split('\n')[0].split('\t');
            let chr = firstLineOfTopHits[0];
            let start = parseInt(firstLineOfTopHits[1]) - 5000;
            let stop = parseInt(firstLineOfTopHits[2]) + 5000;
            let epilogosClientSampleSet = (genome === "mm10") ? "vD" : "vA";
            let epilogosClientApplication = "viewer";
            let epilogosClientMode = "single";
            let epilogosClientComplexity = "KL";
            let epilogosClientGroup = "all";
            let uriEncodedRoiURL = encodeURIComponent(newArchiveURL);
            console.log("newArchiveURL", newArchiveURL);
            console.log("uriEncodedRoiURL", uriEncodedRoiURL);
            let roiMode = "default";
            let roiPaddingFractional = 0.67;
            let srrIdx = 1;
            let activeTab = "roi";
            //
            const md = self.props.jobMetadata;
            const sourceSample = md.sample;
            const targetSample = sample;
            let highlightRows = [];
            let rowSampleMd = Constants.rowMetadataByGenome[genome][stateModel][epilogosClientGroup].samples;
            highlightRows.push(rowSampleMd.indexOf(sourceSample));
            if (sourceSample !== targetSample) {
              highlightRows.push(rowSampleMd.indexOf(targetSample));
            }
            let highlightRowsRawString = highlightRows.join(",");
            let highlightRowsEncodedString = encodeURIComponent(highlightRowsRawString);
            //
            let epilogosViewerURL = `${Constants.epilogosClientHost}/?application=${epilogosClientApplication}&sampleSet=${epilogosClientSampleSet}&mode=${epilogosClientMode}&genome=${genome}&model=${stateModel}&complexity=${epilogosClientComplexity}&group=${epilogosClientGroup}&chrLeft=${chr}&chrRight=${chr}&start=${start}&stop=${stop}&activeTab=${activeTab}&roiMode=${roiMode}&roiPaddingFractional=${roiPaddingFractional}&srrIdx=${srrIdx}&roiURL=${uriEncodedRoiURL}&highlightRows=${highlightRowsEncodedString}`;
            //console.log("epilogosViewerURL", JSON.stringify(epilogosViewerURL));
            window.open(epilogosViewerURL, "_blank");
          })
          .catch(function(error) {
            console.log(error);
          });
      }
      else {
        axios.get(newArchiveURL, { responseType: 'blob' })
          .then(function(response) {
            let fn = `epilogos-search.${epilogoName}.${genome}.${sample}.${backgroundModel}.${pValueThreshold}.${type}.${extension}`
            self.downloadBlobAsFile(new Blob([response.data], {type: "application/octet-stream"}), fn);
          })
          .catch(function(error) {
            console.log(error);
          });
      }
    }
    else if ((name === "resultsEpilogo") || (!name && customObj && customObj.name === "resultsEpilogo")) {
      // you've got to be kidding me, javascript
      const idx = (event.target.dataset && Object.keys(event.target.dataset).length > 0) ? event.target.dataset.idx : customObj.idx;
      const name = (event.target.dataset && Object.keys(event.target.dataset).length > 0) ? event.target.dataset.id : customObj.id;
      //console.log("event.target.dataset, idx, name", event.target.dataset, idx, name);
      this.setState({
        fimoQueryMotifDataIdx: idx,
      }, () => {
        console.log(`idx ${idx}`);
        console.log(`fimoQueryMotifDataIdx ${JSON.stringify(self.state.fimoQueryMotifDataIdx, null, 2)}`);
        console.log("resultsEpilogo now toggling motif data modal");
        this.resetSitesInfiniteTableData();
        this.resetLocationsInfiniteTableData();
        this.fimoQueryMotifDataModalToggle();
      });
    }
    else if ((name === "advancedSearchEpilogo") || (!name && customObj && customObj.name === "advancedSearchEpilogo")) {
      // you've got to be kidding me, javascript
      const idx = (event.target.dataset && Object.keys(event.target.dataset).length > 0) ? event.target.dataset.idx : customObj.idx;
      const name = (event.target.dataset && Object.keys(event.target.dataset).length > 0) ? event.target.dataset.id : customObj.id;
      //console.log("event.target.dataset, idx, name", event.target.dataset, idx, name);
      const item = this.props.memeMotifs.items[idx];
      const model = this.props.memeMotifs.model;
      const assembly = this.props.memeMotifs.assembly;
      const modifiedItem = this.substituteAlphabet(item, model, assembly);
      const newFimoQueryMotifDataAvailable = [...this.state.fimoQueryMotifDataAvailable];
      newFimoQueryMotifDataAvailable[idx] = false;
      this.setState({
        fimoQueryMotifIdx: idx,
        fimoQueryMotifItem: modifiedItem,
        fimoQueryMotifDataAvailable: newFimoQueryMotifDataAvailable,
      }, () => {
        this.fimoQueryModalToggle();
      });
    }
    else if (name === "simpleSearchEpilogo") {
      const idx = parseInt(event.target.dataset.idx);
      const item = this.props.memeMotifs.items[idx];
      const model = this.props.memeMotifs.model;
      const assembly = this.props.memeMotifs.assembly;
      const modifiedItem = this.substituteAlphabet(item, model, assembly);
      const newFimoQueryMotifDataAvailable = [...this.state.fimoQueryMotifDataAvailable];
      
      console.log('simpleSearchEpilogo clicked');
      console.log(`idx ${idx} model ${model} assembly ${assembly} fimoQueryMotifDataAvailable ${newFimoQueryMotifDataAvailable}`);
      
      // build a hex-string identifier from payload components and quit if it is already in the manifest
      const queryManifestJobKeyHashHex = this.manifestJobKeyHashHex(`Epilogo ${parseInt(idx) + 1}`,
                                                                    assembly,
                                                                    this.state.fimoQueryMotifSampleSimples[idx],
                                                                    model,
                                                                    this.state.fimoQueryMotifBackground,
                                                                    this.state.fimoQueryMotifPvalueThreshold);
      //console.log("queryManifestJobKeyHashHex", queryManifestJobKeyHashHex);
      
      if (this.queryManifestJobKeyIsInManifest(queryManifestJobKeyHashHex, idx)) {
        newFimoQueryMotifDataAvailable[idx] = true;
        this.setState({
          fimoQueryMotifDataAvailable: newFimoQueryMotifDataAvailable,
          fimoQueryMotifDataIdx: idx,
          fimoQueryMotifIdx: idx,
          fimoQueryManifestJobKeyHashHex: queryManifestJobKeyHashHex,
          fimoQueryMotifGenome: assembly,
        }, () => {
          this.fimoQueryMotifDataModalToggle();
        });
        return;
      }

      newFimoQueryMotifDataAvailable[idx] = false;
      this.fimoReadyButtonDisableAll();
      this.fimoSimpleButtonDisableAll();
      this.fimoSimpleSampleDisableAll();
      this.fimoHitsButtonDisableAll();
      let newFimoQueryButtonStates = [...this.state.fimoQueryButtonStates];
      newFimoQueryButtonStates[idx] = "inProgress";
      this.setState({
        fimoQueryMotifIdx: idx,
        fimoQueryMotifItem: modifiedItem,
        fimoQueryMotifDataAvailable: newFimoQueryMotifDataAvailable,
        fimoQueryManifestJobKeyHashHex: queryManifestJobKeyHashHex,
        fimoQueryMotifGenome: assembly,
        fimoQueryButtonStates: newFimoQueryButtonStates,
      }, () => {
        let self = this;
        let fimoQueryButtonStates = self.state.fimoQueryButtonStates;
        let fimoQueryPayload = {
          epilogoIdx: idx,
          epilogoName: `Epilogo ${(idx + 1)}`,
          genome: self.state.fimoQueryMotifGenome,
          sample: self.state.fimoQueryMotifSampleSimples[idx],
          stateModel: Constants.epilogosMemeModelsForGenomes[self.state.fimoQueryMotifGenome][self.state.fimoQueryMotifStateModel].model,
          backgroundModel: self.state.fimoQueryMotifBackground,
          pValueThreshold: self.state.fimoQueryMotifPvalueThreshold,
          resultsDirectory: self.state.fimoQueryMotifResultsDirectory,
          memeVersion: self.state.fimoQueryMotifMEMEVersion,
          email: self.state.fimoQueryMotifEmail,
          parentId: self.props.jobMetadata.id,
          memeMotif: self.state.fimoQueryMotifItem
        };
        const formObj = { state: fimoQueryPayload };
        let fimoQueryFailed = false;
        // console.log(`${JSON.stringify(formObj)}`);
        axios.post('/assets/services/submitFimoQuery.py', formObj)
          .then(function(response) {
            var data = response.data;
            var id = data.id;
            var manifest = data.manifest;
            console.log("success", JSON.stringify(manifest, null, 2));
            //fimoQueryButtonStates[self.state.fimoQueryMotifIdx] = "inProgress";
            // start up a timer here that checks periodically for updates to the parentId's fimo manifest.json file
            if (!self.fimoManifestCheckTimerIDs[fimoQueryPayload.epilogoName]) {
              self.initializeFimoManifestCheckTimer(fimoQueryPayload.epilogoName, fimoQueryPayload.epilogoIdx);
            }
          })
          .catch(function(error) {
            console.log("error", error, error.response);
            const fimoQueryMotifFailureMessage = `Error ${error.response.status}: ${error.response.data.error}`;
            self.setState({ fimoQueryMotifFailureMessage : fimoQueryMotifFailureMessage });
            fimoQueryButtonStates[self.state.fimoQueryMotifIdx] = "failed";
            fimoQueryFailed = true;
          })
          .finally(function() {
            self.setState({
              fimoQueryButtonStates: fimoQueryButtonStates
            }, () => {
              if (fimoQueryFailed) {
                setTimeout(() => {
                  fimoQueryButtonStates[self.state.fimoQueryMotifIdx] = "ready";
                  self.setState({ fimoQueryButtonStates: fimoQueryButtonStates });
                  // re-enable all buttons
                  self.fimoReadyButtonEnableAll();
                  self.fimoSimpleButtonEnableAll();
                  self.fimoSimpleSampleEnableAll();
                  self.fimoHitsButtonEnableAll();
                }, 3000);
              }
            });
          });
      });
    }
  }
  
  substituteAlphabet = (item, model, assembly) => {
    const alternateAlphabet = Constants.alternateAlphabets[assembly][model];
    const modifiedItem = item.replace(/ALPHABET= [A-Z]+/gm, alternateAlphabet);
    return modifiedItem;
  }
  
  initializeFimoManifestCheckTimer = (name, idx) => {
    let self = this;
    console.log("TEST initializeFimoManifestCheckTimer", name, idx);
    console.log("TEST self.state.fimoQueryMotifDataAvailable[self.state.fimoQueryMotifIdx]", self.state.fimoQueryMotifIdx, self.state.fimoQueryMotifDataAvailable[self.state.fimoQueryMotifIdx]);
    self.fimoHitsButtonDisableAll();
    if (!self.state.fimoQueryMotifDataAvailable[self.state.fimoQueryMotifIdx]) { 
      this.fimoManifestCheckTimerIDs[name] = setInterval(() => {
        if (self.state.fimoQueryMotifDataAvailable[self.state.fimoQueryMotifIdx]) {
          window.clearInterval(this.fimoManifestCheckTimerIDs[name]);
          self.fimoManifestCheckTimerIDs[name] = null;
          let newFimoQueryMotifDataAvailable = [...self.state.fimoQueryMotifDataAvailable];
          newFimoQueryMotifDataAvailable[self.state.fimoQueryMotifIdx] = false;
          self.setState({
            fimoQueryMotifDataAvailable: newFimoQueryMotifDataAvailable
          })
        }
        else {
          self.queryForFimoManifest(name, idx);
        }
      }, Constants.epilogosFimoManifestCheckRefreshTimer);
    }
  }
  
  cloneObject = (obj) => {
    var copy;
    // Handle the 3 simple types, and null or undefined
    if (null == obj || "object" != typeof obj) return obj;
    // Handle Date
    if (obj instanceof Date) {
      copy = new Date();
      copy.setTime(obj.getTime());
      return copy;
    }
    // Handle Array
    if (obj instanceof Array) {
      copy = [];
      for (var i = 0, len = obj.length; i < len; i++) {
        copy[i] = this.cloneObject(obj[i]);
      }
      return copy;
    }
    // Handle Object
    if (obj instanceof Object) {
      copy = {};
      for (var attr in obj) {
        if (obj.hasOwnProperty(attr)) copy[attr] = this.cloneObject(obj[attr]);
      }
      return copy;
    }  
    throw new Error("Unable to copy obj! Its type isn't supported.");
  }
  
  queryForFimoManifest = (name, idx) => {
    console.log("queryForFimoManifest", name, idx)
    let query = queryString.parse(window.location.search);
    
    if ('id' in query) {
      let self = this;
      console.log(`retrieving manifest for ID ${query.id}`);
      let fimoQueryButtonStates = self.state.fimoQueryButtonStates;
      let fimoManifestQueryFailed = false;
      axios.post('../assets/services/retrieveFimoManifest.py', { id : query.id })
        .then(function(response) {
          const manifest = response.data;
          const jobKeys = Object.keys(manifest.jobs);
          let someJobIsInProgress = false;
          jobKeys.forEach((jk) => {
            const job = manifest.jobs[jk];
            const jobName = job.epilogoName;
            const jobStatus = job.status;
            console.log("testing manifest job", jobName, jobStatus)
            if ((jobName === name) && (jobStatus === "inProgress")) {
              someJobIsInProgress = true;
            }
          });
          if (!someJobIsInProgress) {
            console.log("canceling manifest timer for name/idx", name, idx);
            let newFimoQueryMotifDataAvailable = [...self.state.fimoQueryMotifDataAvailable];
            let newFimoQueryMotifData = self.cloneObject(self.state.fimoQueryMotifData);
            //newFimoQueryMotifDataAvailable[self.state.fimoQueryMotifIdx] = true;
            //newFimoQueryMotifData[self.state.fimoQueryMotifIdx] = self.cloneObject(manifest);
            window.clearInterval(self.fimoManifestCheckTimerIDs[name]);
            self.fimoManifestCheckTimerIDs[name] = null;
            //fimoQueryButtonStates[self.state.fimoQueryMotifIdx] = "ready";
            for (let mi = 0; mi < newFimoQueryMotifDataAvailable.length; mi++) {
              newFimoQueryMotifDataAvailable[mi] = (mi === idx);
            }
            newFimoQueryMotifData[idx] = self.cloneObject(manifest);
            fimoQueryButtonStates[idx] = "ready";
            //fimoHitsButtonIsDisabled
            self.setState({ 
              fimoQueryMotifDataAvailable: newFimoQueryMotifDataAvailable,
              fimoQueryMotifData: newFimoQueryMotifData,
              fimoQueryMotifDataIdx: self.state.fimoQueryMotifIdx
            }, () => {
              self.fimoQueryMotifDataModalToggle();
              // re-enable all buttons
              self.fimoReadyButtonEnableAll();
              self.fimoSimpleButtonEnableAll();
              self.fimoSimpleSampleEnableAll();
              self.fimoHitsButtonEnableAll();
              //console.log("fimoQueryMotifData", JSON.stringify(self.state.fimoQueryMotifData, null, 2));
            });
          }
        })
        .catch(function(error) {
          console.log("manifest error", error);
          const fimoQueryMotifFailureMessage = `Error ${error.response.status}: ${error.response.data.error}`;
          self.setState({ fimoQueryMotifFailureMessage : fimoQueryMotifFailureMessage});
          fimoQueryButtonStates[self.state.fimoQueryMotifIdx] = "failed";
          fimoManifestQueryFailed = true;
        })
        // cleanup
        .finally(function() {
          self.setState({
            fimoQueryButtonStates: fimoQueryButtonStates
          }, () => {
            if (fimoManifestQueryFailed) {
              setTimeout(() => {
                fimoQueryButtonStates[self.state.fimoQueryMotifIdx] = "ready";
                self.setState({ fimoQueryButtonStates: fimoQueryButtonStates });
              }, 3000);
            }
          });
        });
    }
  }
  
  fimoReadyButtonDisable = (idx) => {
    const newFimoReadyButtonIsDisabled = [...this.state.fimoReadyButtonIsDisabled];
    newFimoReadyButtonIsDisabled[idx] = true;
    this.setState({ fimoReadyButtonIsDisabled: newFimoReadyButtonIsDisabled });
  }
  
  fimoReadyButtonDisableAll = () => {
    const newFimoReadyButtonIsDisabled = [...this.state.fimoReadyButtonIsDisabled];
    for (let idx = 0; idx < newFimoReadyButtonIsDisabled.length; idx++) {
      newFimoReadyButtonIsDisabled[idx] = true;
    }
    this.setState({ fimoReadyButtonIsDisabled: newFimoReadyButtonIsDisabled });
  }
  
  fimoReadyButtonEnable = (idx) => {
    const newFimoReadyButtonIsDisabled = [...this.state.fimoReadyButtonIsDisabled];
    newFimoReadyButtonIsDisabled[idx] = false;
    this.setState({ fimoReadyButtonIsDisabled: newFimoReadyButtonIsDisabled });
  }

  fimoReadyButtonEnableAll = () => {
    const newFimoReadyButtonIsDisabled = [...this.state.fimoReadyButtonIsDisabled];
    for (let idx = 0; idx < newFimoReadyButtonIsDisabled.length; idx++) {
      newFimoReadyButtonIsDisabled[idx] = false;
    }
    this.setState({ fimoReadyButtonIsDisabled: newFimoReadyButtonIsDisabled });
  }
  
  fimoSimpleButtonDisable = (idx) => {
    const newFimoSimpleButtonIsDisabled = [...this.state.fimoSimpleButtonIsDisabled];
    newFimoSimpleButtonIsDisabled[idx] = true;
    this.setState({ fimoSimpleButtonIsDisabled: newFimoSimpleButtonIsDisabled });
  }
  
  fimoSimpleButtonDisableAll = () => {
    const newFimoSimpleButtonIsDisabled = [...this.state.fimoReadyButtonIsDisabled];
    for (let idx = 0; idx < newFimoSimpleButtonIsDisabled.length; idx++) {
      newFimoSimpleButtonIsDisabled[idx] = true;
    }
    this.setState({ fimoSimpleButtonIsDisabled: newFimoSimpleButtonIsDisabled });
  }
  
  fimoSimpleButtonEnable = (idx) => {
    const newFimoSimpleButtonIsDisabled = [...this.state.fimoSimpleButtonIsDisabled];
    newFimoSimpleButtonIsDisabled[idx] = false;
    this.setState({ fimoSimpleButtonIsDisabled: newFimoSimpleButtonIsDisabled });
  }
  
  fimoSimpleButtonEnableAll = () => {
    const newFimoSimpleButtonIsDisabled = [...this.state.fimoReadyButtonIsDisabled];
    for (let idx = 0; idx < newFimoSimpleButtonIsDisabled.length; idx++) {
      newFimoSimpleButtonIsDisabled[idx] = false;
    }
    this.setState({ fimoSimpleButtonIsDisabled: newFimoSimpleButtonIsDisabled });
  }
  
  fimoSimpleSampleDisable = (idx) => {
    const newFimoSimpleSampleIsDisabled = [...this.state.fimoSimpleSampleIsDisabled];
    newFimoSimpleSampleIsDisabled[idx] = true;
    this.setState({ fimoSimpleSampleIsDisabled: newFimoSimpleSampleIsDisabled });
  }
  
  fimoSimpleSampleDisableAll = () => {
    const newFimoSimpleSampleIsDisabled = [...this.state.fimoSimpleSampleIsDisabled];
    for (let idx = 0; idx < newFimoSimpleSampleIsDisabled.length; idx++) {
      newFimoSimpleSampleIsDisabled[idx] = true;
    }
    this.setState({ fimoSimpleSampleIsDisabled: newFimoSimpleSampleIsDisabled });
  }
  
  fimoSimpleSampleEnable = (idx) => {
    const newFimoSimpleSampleIsDisabled = [...this.state.fimoSimpleSampleIsDisabled];
    newFimoSimpleSampleIsDisabled[idx] = false;
    this.setState({ fimoSimpleSampleIsDisabled: newFimoSimpleSampleIsDisabled });
  }
  
  fimoSimpleSampleEnableAll = () => {
    const newFimoSimpleSampleIsDisabled = [...this.state.fimoSimpleSampleIsDisabled];
    for (let idx = 0; idx < newFimoSimpleSampleIsDisabled.length; idx++) {
      newFimoSimpleSampleIsDisabled[idx] = false;
    }
    this.setState({ fimoSimpleSampleIsDisabled: newFimoSimpleSampleIsDisabled });
  }
  
  fimoHitsButtonDisable = (idx) => {
    const newFimoHitsButtonIsDisabled = [...this.state.fimoHitsButtonIsDisabled];
    newFimoHitsButtonIsDisabled[idx] = true;
    this.setState({ fimoHitsButtonIsDisabled: newFimoHitsButtonIsDisabled });
  }
  
  fimoHitsButtonDisableAll = () => {
    const newFimoHitsButtonIsDisabled = [...this.state.fimoHitsButtonIsDisabled];
    for (let idx = 0; idx < newFimoHitsButtonIsDisabled.length; idx++) {
      newFimoHitsButtonIsDisabled[idx] = true;
    }
    this.setState({ fimoHitsButtonIsDisabled: newFimoHitsButtonIsDisabled });
  }
  
  fimoHitsButtonEnable = (idx) => {
    const newFimoHitsButtonIsDisabled = [...this.state.fimoHitsButtonIsDisabled];
    newFimoHitsButtonIsDisabled[idx] = false;
    this.setState({ fimoHitsButtonIsDisabled: newFimoHitsButtonIsDisabled });
  }
  
  fimoHitsButtonEnableAll = () => {
    const newFimoHitsButtonIsDisabled = [...this.state.fimoHitsButtonIsDisabled];
    for (let idx = 0; idx < newFimoHitsButtonIsDisabled.length; idx++) {
      newFimoHitsButtonIsDisabled[idx] = false;
    }
    this.setState({ fimoHitsButtonIsDisabled: newFimoHitsButtonIsDisabled });
  }
  
  fimoQueryTrigger = () => {
    
    let self = this;
    
    // build a hex-string identifier from payload components and quit if it is already in the manifest
    const queryManifestJobKeyHashHex = this.manifestJobKeyHashHex(`Epilogo ${parseInt(self.state.fimoQueryMotifIdx) + 1}`,
                                                                  self.state.fimoQueryMotifGenome,
                                                                  self.state.fimoQueryMotifSample,
                                                                  Constants.epilogosMemeModelsForGenomes[self.state.fimoQueryMotifGenome][self.state.fimoQueryMotifStateModel].model,
                                                                  self.state.fimoQueryMotifBackground,
                                                                  self.state.fimoQueryMotifPvalueThreshold);

    console.log("testing...",`Epilogo ${parseInt(self.state.fimoQueryMotifIdx) + 1}`,
                              self.state.fimoQueryMotifGenome,
                              self.state.fimoQueryMotifSample,
                              Constants.epilogosMemeModelsForGenomes[self.state.fimoQueryMotifGenome][self.state.fimoQueryMotifStateModel].model,
                              self.state.fimoQueryMotifBackground,
                              self.state.fimoQueryMotifPvalueThreshold);
                              
    if (this.queryManifestJobKeyIsInManifest(queryManifestJobKeyHashHex, self.state.fimoQueryMotifIdx)) {
      const newFimoQueryMotifDataAvailable = [...this.state.fimoQueryMotifDataAvailable];
      newFimoQueryMotifDataAvailable[this.state.fimoQueryMotifIdx] = true;
      this.setState({
        fimoQueryMotifDataAvailable: newFimoQueryMotifDataAvailable,
        fimoQueryMotifDataIdx: this.state.fimoQueryMotifIdx,
      }, () => {
        // push out fimo modal and bring in fimo datatable
        self.fimoQueryModalToggle();
        self.fimoQueryMotifDataModalToggle();
      });
      console.log("stopping here");
      return;
    }
    
    //console.log("self.props.jobMetadata", JSON.stringify(self.props.jobMetadata, null, 2));
    
    // disable all fimo advanced-search buttons and the hits button (whether visible or not)
    self.fimoReadyButtonDisableAll();
    self.fimoSimpleButtonDisableAll();
    self.fimoSimpleSampleDisableAll();
    self.fimoHitsButtonDisableAll();
    
    let fimoQueryButtonStates = self.state.fimoQueryButtonStates;
    fimoQueryButtonStates[self.state.fimoQueryMotifIdx] = "inProgress";
    
    self.setState({
      fimoQueryButtonStates: fimoQueryButtonStates
    }, () => {
      // hide modal
      self.fimoQueryModalToggle();  

      // send payload off for analysis
      let fimoQueryPayload = {
        epilogoIdx: self.state.fimoQueryMotifIdx,
        epilogoName: `Epilogo ${parseInt(self.state.fimoQueryMotifIdx) + 1}`,
        genome: self.state.fimoQueryMotifGenome,
        sample: self.state.fimoQueryMotifSample,
        stateModel: Constants.epilogosMemeModelsForGenomes[self.state.fimoQueryMotifGenome][self.state.fimoQueryMotifStateModel].model,
        backgroundModel: self.state.fimoQueryMotifBackground,
        pValueThreshold: self.state.fimoQueryMotifPvalueThreshold,
        resultsDirectory: self.state.fimoQueryMotifResultsDirectory,
        memeVersion: self.state.fimoQueryMotifMEMEVersion,
        email: self.state.fimoQueryMotifEmail,
        parentId: self.props.jobMetadata.id,
        memeMotif: self.state.fimoQueryMotifItem
      };
      
      const formObj = { state: fimoQueryPayload };
      
      //console.log("fimoQueryPayload", JSON.stringify(formObj, null, 2));
      
      let fimoQueryFailed = false;
      axios.post('/assets/services/submitFimoQuery.py', formObj)
        // success
        .then(function(response) {
          var data = response.data;
          var id = data.id;
          var manifest = data.manifest;
          console.log("success", JSON.stringify(manifest, null, 2));
          fimoQueryButtonStates[self.state.fimoQueryMotifIdx] = "inProgress";
          const newFimoQueryMotifDataAvailable = [...self.state.fimoQueryMotifDataAvailable];
          newFimoQueryMotifDataAvailable[self.state.fimoQueryMotifIdx] = false;
          self.setState({
            fimoQueryManifestJobKeyHashHex: queryManifestJobKeyHashHex,
            fimoQueryMotifDataAvailable: newFimoQueryMotifDataAvailable,
            fimoQueryMotifDataIdx: self.state.fimoQueryMotifIdx,
          }, () => {
            // start up a timer here that checks periodically for updates to the parentId's fimo manifest.json file
            if (!self.fimoManifestCheckTimerIDs[fimoQueryPayload.epilogoName]) {
              self.initializeFimoManifestCheckTimer(fimoQueryPayload.epilogoName, fimoQueryPayload.epilogoIdx);
            }
          })
        })
        // failure
        .catch(function(error) {
          console.log("error", error, error.response);
          const fimoQueryMotifFailureMessage = `Error ${error.response.status}: ${error.response.data.error}`;
          self.setState({ fimoQueryMotifFailureMessage : fimoQueryMotifFailureMessage });
          fimoQueryButtonStates[self.state.fimoQueryMotifIdx] = "failed";
          fimoQueryFailed = true;
        })
        // cleanup
        .finally(function() {
          self.setState({
            fimoQueryButtonStates: fimoQueryButtonStates
          }, () => {
            if (fimoQueryFailed) {
              setTimeout(() => {
                fimoQueryButtonStates[self.state.fimoQueryMotifIdx] = "ready";
                self.setState({ fimoQueryButtonStates: fimoQueryButtonStates });
                // re-enable all buttons
                self.fimoReadyButtonEnableAll();
                self.fimoSimpleButtonEnableAll();
                self.fimoSimpleSampleEnableAll();
                self.fimoHitsButtonEnableAll();
              }, 3000);
            }
          });
        });
    })
  }
  
  manifestJobKeyHashHex = (epilogoName, assembly, sample, stateModel, backgroundModel, pValueThreshold) => {
    const manifestJobKey = `${epilogoName}.${assembly}.${sample}.${stateModel}.${backgroundModel}.${pValueThreshold}`;
    const manifestJobKeyHash = CryptoJS.SHA1(manifestJobKey);
    const manifestJobKeyHashHex = manifestJobKeyHash.toString(CryptoJS.enc.Hex);
    return manifestJobKeyHashHex;
  }
  
  queryManifestJobKeyIsInManifest = (queryManifestJobKeyHashHex, idx) => {
    //console.log("queryManifestJobKeyIsInManifest > testing", queryManifestJobKeyHashHex, idx);
    if (this.state.fimoQueryMotifData) {
      //console.log("queryManifestJobKeyIsInManifest > fimoQueryMotifData", this.state.fimoQueryMotifData);
      let fimoQueryMotifDataKeyFound = false;
      let fimoQueryMotifDataForIdx = this.state.fimoQueryMotifData[idx];
      if (!fimoQueryMotifDataForIdx) return false;
      if (fimoQueryMotifDataForIdx.jobs) {
        const fimoQueryMotifDataManifestJobKeys = Object.keys(fimoQueryMotifDataForIdx.jobs);
        //console.log("fimoQueryMotifDataManifestJobKeys", fimoQueryMotifDataManifestJobKeys);
        //console.log("fimoQueryMotifDataManifestJobKeys.indexOf(queryManifestJobKeyHashHex)", fimoQueryMotifDataManifestJobKeys.indexOf(queryManifestJobKeyHashHex));
        if (fimoQueryMotifDataManifestJobKeys.indexOf(queryManifestJobKeyHashHex) !== -1) {
          //console.log("fimoQueryMotifDataForIdx.jobs[queryManifestJobKeyHashHex]", fimoQueryMotifDataForIdx.jobs[queryManifestJobKeyHashHex]);
          if (fimoQueryMotifDataForIdx.jobs[queryManifestJobKeyHashHex] === "finished") {
            fimoQueryMotifDataKeyFound = true;
            return;
          }
        }
      }
/*
      this.state.fimoQueryMotifData.forEach((d, i) => {
        console.log("i", i);
        if (d && d.jobs) { 
          const fimoQueryMotifDataManifestJobKeys = Object.keys(d.jobs);
          console.log("fimoQueryMotifDataManifestJobKeys", fimoQueryMotifDataManifestJobKeys);
          console.log("fimoQueryMotifDataManifestJobKeys.indexOf(queryManifestJobKeyHashHex)", fimoQueryMotifDataManifestJobKeys.indexOf(queryManifestJobKeyHashHex));
          if (fimoQueryMotifDataManifestJobKeys.indexOf(queryManifestJobKeyHashHex) !== -1) {
            console.log("d.jobs[queryManifestJobKeyHashHex]", d.jobs[queryManifestJobKeyHashHex]);
            if (d.jobs[queryManifestJobKeyHashHex] === "finished") {
              fimoQueryMotifDataKeyFound = true;
              return;
            }
          }
        }
      });
*/
      if (fimoQueryMotifDataKeyFound) {
        return true;
      }
    }
    if (this.props.fimoManifest && this.props.fimoManifest.jobs) {
      const manifestJobKeys = Object.keys(this.props.fimoManifest.jobs);
      if (manifestJobKeys.indexOf(queryManifestJobKeyHashHex) !== -1) {
        //console.log("this.props.fimoManifest.jobs[queryManifestJobKeyHashHex].status", this.props.fimoManifest.jobs[queryManifestJobKeyHashHex].status)
        if (this.props.fimoManifest.jobs[queryManifestJobKeyHashHex].status === "finished") {
          return true;
        }
      }
    }
    return false;
  };
  
  fimoQueryModalToggle = () => {
    //ReactTooltip.rebuild();
    if (this.props.fimoManifest) {
      let newFimoQueryMotifDataAvailable = this.state.fimoQueryMotifDataAvailable;
      let newFimoQueryMotifData = this.state.fimoQueryMotifData;
      const jobKeys = Object.keys(this.props.fimoManifest.jobs);
      jobKeys.forEach((jk) => {
        const job = this.props.fimoManifest.jobs[jk];
        const jobIdx = job.epilogoIdx;
        const jobName = job.epilogoName;
        const jobStatus = job.status;
        if (jobStatus === "finished") {
          newFimoQueryMotifData[jobIdx] = this.cloneObject(this.props.fimoManifest);
          newFimoQueryMotifDataAvailable[jobIdx] = true;
        }           
      });
      this.setState({
        fimoQueryMotifDataAvailable: newFimoQueryMotifDataAvailable,
        fimoQueryMotifData: newFimoQueryMotifData,
      })
    }
    this.setState({
      fimoQueryModalIsOpen: !this.state.fimoQueryModalIsOpen
    });
  }
  
  fimoQueryMotifDataModalToggle = () => {
    //ReactTooltip.rebuild();
    this.setState({
      fimoQueryMotifDataModalIsOpen: !this.state.fimoQueryMotifDataModalIsOpen
    });
  }
  
  fimoQueryMotifDataSelectedSampleMatches = (job, sample, genome, epilogoName, background, pValueThreshold) => {
    if (!background) return false;
    if (!pValueThreshold) return false;
    //console.log(`fimoQueryMotifDataSelectedSampleMatches: ${job} ${sample}, ${genome}, ${epilogoName}, ${background}, ${pValueThreshold}`);
    //return ((job.sample === sample) && (job.genome === genome) && (job.epilogoName === epilogoName) && (job.backgroundModel === background) && (job.pValueThreshold === pValueThreshold));
    return ((job.sample === sample) && (job.epilogoName === epilogoName));
  }
  
  fimoQueryMotifDataTable = () => { 
    if (!this.state.fimoQueryMotifDataModalIsOpen) return;
    if (typeof this.state.fimoQueryMotifDataIdx === "undefined") return;
    //console.log(`this.state.fimoQueryMotifData ${JSON.stringify(this.state.fimoQueryMotifData, null, 2)}`);
    const motifData = this.state.fimoQueryMotifData[this.state.fimoQueryMotifDataIdx];
    if (!motifData) return;
    //console.log("this.state.fimoQueryMotifData[this.state.fimoQueryMotifDataIdx]", this.state.fimoQueryMotifData[this.state.fimoQueryMotifDataIdx]);
    //console.log("this.state.fimoQueryMotifDataIdx", this.state.fimoQueryMotifDataIdx);
    //console.log("motifData", motifData);
    const jobKeys = Object.keys(motifData.jobs);
    const targetEpilogoName = `Epilogo ${(parseInt(this.state.fimoQueryMotifDataIdx) + 1)}`;
    //console.log("targetEpilogoName", targetEpilogoName)
    let tableRows = [];
    const sampleDetail = (g, s) => `${s} - ${Constants.epilogosMemeSamplesKV[g][s]}`;
    //const manifestJobSelectionHighlight = { backgroundColor: "lightslategray", color: "white", fontWeight: "600" };
    const manifestJobSelectionHighlight = { backgroundColor: "#ececec", fontWeight: "600" };
    const manifestJobSelectionHexMatchHighlightLeftCell = { backgroundColor: "#dcdcdc", fontWeight: "600", borderColor:"#cecece", borderStyle:"solid", borderLeftWidth:"2px", borderBottomWidth:"2px", borderTopWidth:"2px" };
    const manifestJobSelectionHexMatchHighlightMiddleCell = { backgroundColor: "#dcdcdc", fontWeight: "600", borderColor:"#cecece", borderStyle:"solid", borderBottomWidth:"2px", borderTopWidth:"2px" };
    const manifestJobSelectionHexMatchHighlightRightCell = { backgroundColor: "#dcdcdc", fontWeight: "600", borderColor:"#cecece", borderStyle:"solid", borderRightWidth:"2px", borderBottomWidth:"2px", borderTopWidth:"2px" };
    const firstRemainingJobHighlight = { borderTop: "1px #dcdcdc solid" };
    let selectedTableRowJobData = [];
    let matchingTableRowJobData = [];
    let tableRowJobData = [];
    jobKeys.forEach((jk, jki) => {
      const job = motifData.jobs[jk];
      //console.log("fimoQueryMotifDataTable > job", job);
      if (job.epilogoName === targetEpilogoName) {
        //console.log("fimoQueryMotifDataTable > this.state.fimoQueryMotifDataIdx", this.state.fimoQueryMotifDataIdx)
//         if (job.id === this.state.fimoQueryManifestJobKeyHashHex) {
        let epilogoIdx = this.state.fimoQueryMotifDataIdx;
        let epilogoSample = this.state.fimoQueryMotifSampleSimples[epilogoIdx];
        let epilogoGenome = this.state.fimoQueryMotifGenome;
        let epilogoName = targetEpilogoName;
        let epilogoBackground = this.state.fimoQueryMotifBackground;
        let epilogoPvalueThreshold = this.state.fimoQueryMotifPvalueThreshold;
/*
        console.warn(`testing: ${epilogoIdx}`);
        console.warn(`         ${this.state.fimoQueryMotifSampleSimples}`);
        console.warn(`         ${epilogoSample}`);
        console.warn(`         ${epilogoGenome}`);
        console.warn(`         ${epilogoName}`);
*/
        if (job.id === this.state.fimoQueryManifestJobKeyHashHex) {
          selectedTableRowJobData.push(job);
        }
        else if (this.fimoQueryMotifDataSelectedSampleMatches(
          job, 
          epilogoSample, 
          epilogoGenome, 
          epilogoName,
          epilogoBackground,
          epilogoPvalueThreshold)
        ) {
          matchingTableRowJobData.push(job);
        }
        else {
          tableRowJobData.push({ sample: job.sample, job : job });
        }
      }
    });
    function tableRowSortFunctor(a, b) {
      if (a.sample > b.sample) {
        return 1;
      }
      else if (a.sample < b.sample) {
        return -1;
      }
      else {
        if (a.genome > b.genome) {
          return 1;
        }
        else if (a.genome < b.genome) {
          return -1;
        }
        else {
          if (a.pValueThreshold > b.pValueThreshold) {
            return 1;
          }
          else if (a.pValueThreshold < b.pValueThreshold) {
            return -1;
          }
          else {
            if (a.backgroundModel > b.backgroundModel) {
              return 1;
            }
            else {
              return -1;
            }
          }
        }
      }
    }
    matchingTableRowJobData.sort(tableRowSortFunctor);
    tableRowJobData.sort(tableRowSortFunctor);
    //console.log("tableRowJobData", tableRowJobData);
    let remainingTableRowJobData = [];
    for (let o in tableRowJobData) {  
      remainingTableRowJobData.push(this.cloneObject(tableRowJobData[o].job));
    }
    //console.log("remainingTableRowJobData", remainingTableRowJobData);
    const jobs = selectedTableRowJobData.concat(matchingTableRowJobData).concat(remainingTableRowJobData);
    const firstRemainingJobId = selectedTableRowJobData.length + matchingTableRowJobData.length;
    jobs.forEach((job, jki) => {
      if (job.epilogoName === targetEpilogoName) {
        //console.log("pushing table row", job);
        let epilogoIdx = this.state.fimoQueryMotifDataIdx;
        let epilogoSample = this.state.fimoQueryMotifSampleSimples[epilogoIdx];
        let epilogoGenome = this.state.fimoQueryMotifGenome;
        let epilogoName = targetEpilogoName;
        let epilogoBackground = this.state.fimoQueryMotifBackground;
        let epilogoPvalueThreshold = this.state.fimoQueryMotifPvalueThreshold;
        let hashMatches = (job.id === this.state.fimoQueryManifestJobKeyHashHex);
        let rowMatches = this.fimoQueryMotifDataSelectedSampleMatches(
          job, 
          epilogoSample, 
          epilogoGenome, 
          epilogoName,
          epilogoBackground,
          epilogoPvalueThreshold);
        //console.warn(`rowMatches: ${rowMatches}`);
        tableRows.push(
          <tr key={`fimo-query-modal-data-table-row-${jki}`}> 
            <td className="fimo-query-modal-table-parameter" style={(hashMatches) ? manifestJobSelectionHexMatchHighlightLeftCell : (rowMatches) ? manifestJobSelectionHighlight : (firstRemainingJobId === jki) ? firstRemainingJobHighlight : {}}>{job.genome}</td>
            <td 
              className="fimo-query-modal-table-parameter fimo-query-modal-table-parameter-sample" 
              style={(hashMatches) ? manifestJobSelectionHexMatchHighlightMiddleCell : (rowMatches) ? manifestJobSelectionHighlight : (firstRemainingJobId === jki) ? firstRemainingJobHighlight : {}} 
              >
              <span 
                style={{position:"relative",top:"-1px"}}
                data-for="location-tooltip"
                data-place="right"
                data-type="dark"
                data-effect="solid"
                data-tip={`<span class="view-container-tooltip">${sampleDetail(job.genome, job.sample)}`}
                onMouseEnter={
                  (e) => { 
                    //console.log('mouseEnter', sampleDetail(job.genome, job.sample)); 
                    ReactTooltip.rebuild();
                    ReactTooltip.show(this.locationTooltipRef);
                  }
                } 
                onMouseLeave={
                  (e) => { 
                    //console.log('mouseLeave'); 
                    ReactTooltip.hide(this.locationTooltipRef)
                  }
                }
                ><FaInfoCircle />
              </span>
                {"  "}
              <span title={sampleDetail(job.genome, job.sample)}>{job.sample}</span>
            </td>
            <td className="fimo-query-modal-table-parameter fimo-query-modal-table-parameter-elements" style={(hashMatches) ? manifestJobSelectionHexMatchHighlightMiddleCell : (rowMatches) ? manifestJobSelectionHighlight : (firstRemainingJobId === jki) ? firstRemainingJobHighlight : {}}>{job.elements}</td>
            <td className="fimo-query-modal-table-parameter fimo-query-modal-table-parameter-backgroundModel" style={(hashMatches) ? manifestJobSelectionHexMatchHighlightMiddleCell : (rowMatches) ? manifestJobSelectionHighlight : (firstRemainingJobId === jki) ? firstRemainingJobHighlight : {}}>{job.backgroundModel}</td>
            <td className="fimo-query-modal-table-parameter fimo-query-modal-table-parameter-pValueThreshold" style={(hashMatches) ? manifestJobSelectionHexMatchHighlightMiddleCell : (rowMatches) ? manifestJobSelectionHighlight : (firstRemainingJobId === jki) ? firstRemainingJobHighlight : {}}>{job.pValueThreshold.toExponential(0)}</td>
            <td 
              className="fimo-query-modal-table-parameter fimo-query-modal-table-parameter-download-control"
              style={(hashMatches) ? manifestJobSelectionHexMatchHighlightMiddleCell : (rowMatches) ? manifestJobSelectionHighlight : (firstRemainingJobId === jki) ? firstRemainingJobHighlight : {}}>
              <div
                onClick={(e) => {
                    this.handleClick(e, {
                      'name': 'downloadEpilogoFimoMotifAllHits',
                      'id': job.id,
                      'type': 'allHits',
                      'epilogoName':  `Epilogo-${(parseInt(this.state.fimoQueryMotifDataIdx) + 1)}`,
                      'extension': 'bed.gz',
                      'idx': this.state.fimoQueryMotifDataIdx,
                      'path': job.allGz,
                      'sample': job.sample,
                      'genome': job.genome,
                      'backgroundModel': job.backgroundModel,
                      'pValueThreshold': job.pValueThreshold
                    });
                  }}>
                <Button 
                  size="sm"
                  className="btn-download btn-epilogos" 
                  color="primary" 
                  key={`downloadEpilogoFimoMotifAllHits-${parseInt(this.state.fimoQueryMotifDataIdx)}`}
                  name="downloadEpilogoFimoMotifAllHits"
                  data-id={job.id}
                  data-type={'allHits'}
                  data-epilogoname={`Epilogo-${(parseInt(this.state.fimoQueryMotifDataIdx) + 1)}`}
                  data-extension={'bed.gz'}
                  data-idx={this.state.fimoQueryMotifDataIdx}
                  data-path={job.allGz}
                  data-sample={job.sample}
                  data-genome={job.genome}
                  data-backgroundmodel={job.backgroundModel}
                  data-pvaluethreshold={job.pValueThreshold}
                  ref={(thisButton) => {this.downloadItemButton = thisButton}}
                  onClick={(e) => {
                      this.handleClick(e, {
                        'name': 'downloadEpilogoFimoMotifAllHits',
                        'id': job.id,
                        'type': 'allHits',
                        'epilogoName':  `Epilogo-${(parseInt(this.state.fimoQueryMotifDataIdx) + 1)}`,
                        'extension': 'bed.gz',
                        'idx': this.state.fimoQueryMotifDataIdx,
                        'path': job.allGz,
                        'sample': job.sample,
                        'genome': job.genome,
                        'backgroundModel': job.backgroundModel,
                        'pValueThreshold': job.pValueThreshold
                      });
                    }} >
                  <FaDownload 
                    onClick={(e) => {
                      this.handleClick(e, {
                        'name': 'downloadEpilogoFimoMotifAllHits',
                        'id': job.id,
                        'type': 'allHits',
                        'epilogoName':  `Epilogo-${(parseInt(this.state.fimoQueryMotifDataIdx) + 1)}`,
                        'extension': 'bed.gz',
                        'idx': this.state.fimoQueryMotifDataIdx,
                        'path': job.allGz,
                        'sample': job.sample,
                        'genome': job.genome,
                        'backgroundModel': job.backgroundModel,
                        'pValueThreshold': job.pValueThreshold
                      });
                    }} /> 
                </Button>
              </div>
            </td>
            <td className="fimo-query-modal-table-parameter fimo-query-modal-table-parameter-download-control" style={(hashMatches) ? manifestJobSelectionHexMatchHighlightMiddleCell : (rowMatches) ? manifestJobSelectionHighlight : (firstRemainingJobId === jki) ? firstRemainingJobHighlight : {}}>
              <div
                onClick={(e) => {
                  this.handleClick(e, {
                    'name': 'downloadEpilogoFimoMotifTop100Hits',
                    'id': job.id,
                    'type': 'top100Hits',
                    'epilogoName':  `Epilogo-${(parseInt(this.state.fimoQueryMotifDataIdx) + 1)}`,
                    'extension': 'bed.gz',
                    'idx': this.state.fimoQueryMotifDataIdx,
                    'path': job.top100Hits,
                    'sample': job.sample,
                    'genome': job.genome,
                    'backgroundModel': job.backgroundModel,
                    'pValueThreshold': job.pValueThreshold
                  });
                }} >
                <Button 
                  size="sm"
                  className="btn-download btn-epilogos" 
                  color="primary" 
                  key={`downloadEpilogoFimoMotifTop100Hits-${parseInt(this.state.fimoQueryMotifDataIdx)}`}
                  name="downloadEpilogoFimoMotifTop100Hits"
                  data-id={job.id}
                  data-type={'top100Hits'}
                  data-epilogoname={`Epilogo-${(parseInt(this.state.fimoQueryMotifDataIdx) + 1)}`}
                  data-extension={'txt'}
                  data-idx={this.state.fimoQueryMotifDataIdx}
                  data-path={job.top100Hits}
                  data-sample={job.sample}
                  data-genome={job.genome}
                  data-backgroundmodel={job.backgroundModel}
                  data-pvaluethreshold={job.pValueThreshold}
                  ref={(thisButton) => {this.downloadItemButton = thisButton}}
                  onClick={(e) => {
                    this.handleClick(e, {
                      'name': 'downloadEpilogoFimoMotifTop100Hits',
                      'id': job.id,
                      'type': 'top100Hits',
                      'epilogoName':  `Epilogo-${(parseInt(this.state.fimoQueryMotifDataIdx) + 1)}`,
                      'extension': 'bed.gz',
                      'idx': this.state.fimoQueryMotifDataIdx,
                      'path': job.top100Hits,
                      'sample': job.sample,
                      'genome': job.genome,
                      'backgroundModel': job.backgroundModel,
                      'pValueThreshold': job.pValueThreshold
                    });
                  }} >
                  <FaDownload
                    onClick={(e) => {
                      this.handleClick(e, {
                        'name': 'downloadEpilogoFimoMotifTop100Hits',
                        'id': job.id,
                        'type': 'top100Hits',
                        'epilogoName':  `Epilogo-${(parseInt(this.state.fimoQueryMotifDataIdx) + 1)}`,
                        'extension': 'bed.gz',
                        'idx': this.state.fimoQueryMotifDataIdx,
                        'path': job.top100Hits,
                        'sample': job.sample,
                        'genome': job.genome,
                        'backgroundModel': job.backgroundModel,
                        'pValueThreshold': job.pValueThreshold
                      });
                    }} />
                </Button>
              </div>
            </td>
            <td className="fimo-query-modal-table-parameter fimo-query-modal-table-parameter-download-control" style={(hashMatches) ? manifestJobSelectionHexMatchHighlightRightCell : (rowMatches) ? manifestJobSelectionHighlight : (firstRemainingJobId === jki) ? firstRemainingJobHighlight : {}}>
            <div
              onClick={(e) => {
                this.handleClick(e, {
                  'name': 'viewEpilogoFimoMotifTop100Hits',
                  'id': job.id,
                  'type': 'viewTop100Hits',
                  'epilogoName':  `Epilogo-${(parseInt(this.state.fimoQueryMotifDataIdx) + 1)}`,
                  'extension': 'bed.gz',
                  'idx': this.state.fimoQueryMotifDataIdx,
                  'path': job.top100Hits,
                  'sample': job.sample,
                  'genome': job.genome,
                  'backgroundModel': job.backgroundModel,
                  'pValueThreshold': job.pValueThreshold,
                  'stateModel': this.props.model
                });
              }} >
                <Button 
                  size="sm"
                  className="btn-viewer btn-epilogos" 
                  color="primary"
                  key={`viewEpilogoFimoMotifTop100Hits-${parseInt(this.state.fimoQueryMotifDataIdx)}`}
                  name="viewEpilogoFimoMotifTop100Hits"
                  data-id={job.id}
                  data-type={'viewTop100Hits'}
                  data-epilogoname={`Epilogo-${(parseInt(this.state.fimoQueryMotifDataIdx) + 1)}`}
                  data-idx={this.state.fimoQueryMotifDataIdx}
                  data-path={job.top100Hits}
                  data-sample={job.sample}
                  data-genome={job.genome}
                  data-backgroundmodel={job.backgroundModel}
                  data-pvaluethreshold={job.pValueThreshold}
                  data-statemodel={this.props.model}
                  ref={(thisButton) => {this.downloadItemButton = thisButton}}
                  onClick={(e) => {
                    this.handleClick(e, {
                      'name': 'viewEpilogoFimoMotifTop100Hits',
                      'id': job.id,
                      'type': 'viewTop100Hits',
                      'epilogoName':  `Epilogo-${(parseInt(this.state.fimoQueryMotifDataIdx) + 1)}`,
                      'extension': 'bed.gz',
                      'idx': this.state.fimoQueryMotifDataIdx,
                      'path': job.top100Hits,
                      'sample': job.sample,
                      'genome': job.genome,
                      'backgroundModel': job.backgroundModel,
                      'pValueThreshold': job.pValueThreshold,
                      'stateModel': this.props.model
                    });
                  }} >
                  <FaRegEye 
                    onClick={(e) => {
                      this.handleClick(e, {
                        'name': 'viewEpilogoFimoMotifTop100Hits',
                        'id': job.id,
                        'type': 'viewTop100Hits',
                        'epilogoName':  `Epilogo-${(parseInt(this.state.fimoQueryMotifDataIdx) + 1)}`,
                        'extension': 'bed.gz',
                        'idx': this.state.fimoQueryMotifDataIdx,
                        'path': job.top100Hits,
                        'sample': job.sample,
                        'genome': job.genome,
                        'backgroundModel': job.backgroundModel,
                        'pValueThreshold': job.pValueThreshold,
                        'stateModel': this.props.model
                      });
                    }} />
                </Button>
              </div>
            </td>
          </tr>
        )
      }
    });
    return (
      <div className="fimo-query-motif-data-table">
        <Table striped borderless hover style={{borderCollapse:"separate", borderSpacing:"0px"}}>
          <thead>
            <tr>
              <th className="rotate"><div><span>Genome</span></div></th>
              <th className="rotate"><div><span>Biosample</span></div></th>
              <th className="rotate"><div><span>Hits</span></div></th>
              <th className="rotate"><div><span>Background model</span></div></th>
              <th className="rotate"><div><span>P-value threshold</span></div></th>
              <th className="rotate"><div><span>All hits (.gz)</span></div></th>
              <th className="rotate"><div><span>Top-100 hits (.gz)</span></div></th>
              <th className="rotate"><div><span>View</span></div></th>
            </tr>
          </thead>
          <tbody>
            {tableRows}
          </tbody>
        </Table>
      </div>
    )
  }
  
  fimoQueryModalDataIsValid = () => {
    let dataIsValid = false;
    if (this.state.fimoQueryMotifPvalueThreshold > 0 && this.state.fimoQueryMotifPvalueThreshold < 1)
      dataIsValid = true;
    return dataIsValid;
  }
  
  fimoQueryModalTableGenomeSectionBody = () => {
    let activeGenome = this.state.fimoQueryMotifGenome;
    let kButtons = [];
    let kButtonIdx = 0;
    Object.keys(Constants.epilogosMemeGenomesForSettings).forEach(k => {
      if (k === "Mouse" && this.props.jobMetadata.stateModel !== "Observed (15-state)") return;
      if (k !== "Mouse" && activeGenome === "mm10") return;
      if (k !== "Human" && ((activeGenome === "hg19") || (activeGenome === "hg38"))) return;
      let kButtonLabels = Constants.epilogosMemeGenomesForSettings[k];
      const kButtonPrefix = 'genome-bg-btn-';
      const kButtonParentPrefix = 'genome-bg-parent-btn-';
      kButtonLabels.forEach((label) => {
        const isActive = (activeGenome === label);
        const isDisabled = false;
        let kButtonKey = kButtonPrefix + kButtonIdx;
        let kButtonParentKey = kButtonParentPrefix + kButtonIdx;
        let formattedLabel = <span style={{fontWeight:(isActive)?600:100}}>{label}</span>;
        kButtons.push(<div key={kButtonParentKey}><input id={kButtonKey} key={kButtonKey} type="radio" checked={isActive} disabled={isDisabled} name="genome" value={label} onChange={()=>{}} onClick={(e) => { this.setState({fimoQueryMotifGenome:e.target.value}) }} />{' '}<label className="form-label" htmlFor={kButtonKey}>{formattedLabel}</label></div>);
        kButtonIdx++;
      });
    });
    const kSectionBodyKey = 'genome-sb';
    return <FormGroup key={kSectionBodyKey} check className="form-group-radio">{kButtons}<div style={{fontSize:"0.8em", paddingTop:"10px"}}>{(this.props.jobMetadata.stateModel === "Observed (15-state)") ? "" : "Mouse assembly unavailable for epilogos derived from 18- or 25-state models"}</div></FormGroup>;
  }
  
  fimoQueryModalTableSampleSectionBody = (genome, model) => {
    switch (model) {
      case Constants.epilogosMemeStateModelObserved:
        return Constants.epilogosMemeObservedSamples[genome].map(this.fimoQueryModalTableMakeOptionFromObjectArray, "sample");
      case Constants.epilogosMemeStateModelObservedAux:
        return Constants.epilogosMemeObservedAuxSamples[genome].map(this.fimoQueryModalTableMakeOptionFromObjectArray, "sample");
      case Constants.epilogosMemeStateModelImputed:
        return Constants.epilogosMemeImputedSamples[genome].map(this.fimoQueryModalTableMakeOptionFromObjectArray, "sample");
      default:
        return null;
    }
  };
  
  fimoQueryModalTableSampleSimpleSectionBody = (genome, model) => {
    switch (model) {
      case Constants.epilogosMemeStateModelObserved:
        return Constants.epilogosMemeObservedSamples[genome].map(this.fimoQueryModalTableMakeSimpleOptionFromObjectArray, "sample");
      case Constants.epilogosMemeStateModelObservedAux:
        return Constants.epilogosMemeObservedAuxSamples[genome].map(this.fimoQueryModalTableMakeSimpleOptionFromObjectArray, "sample");
      case Constants.epilogosMemeStateModelImputed:
        return Constants.epilogosMemeImputedSamples[genome].map(this.fimoQueryModalTableMakeSimpleOptionFromObjectArray, "sample");
      default:
        return null;
    }
  };

  fimoQueryModalTableMakeOptionFromObjectArray = (o, n) => {
    let k = Object.keys(o)[0];
    return <option name={n} key={k} value={k}>{k} - {o[k]}</option>;
  };
  
  fimoQueryModalTableMakeSimpleOptionFromObjectArray = (o, n) => {
    let k = Object.keys(o)[0];
    return <option name={n} key={k} value={k}>{k}</option>;
  };
  
  fimoQueryModalShowTooltip = (e, label) => {
    const tooltip = document.getElementById("view-container-tooltip");
    tooltip.innerHTML = label;
    tooltip.style.display = "block";
    const rect = tooltip.getBoundingClientRect();
    tooltip.style.left = e.pageX + 10 + 'px';
    tooltip.style.top = e.pageY - 5 - rect.height + 'px';
  };
  
  fimoQueryModalHideTooltip = () => {
    const tooltip = document.getElementById("view-container-tooltip");
    tooltip.style.display = "none";
  };
  
  fimoQueryModalTableBackgroundSectionBody = () => {
    let activeBackground = this.state.fimoQueryMotifBackground;
    let activeSample = this.state.fimoQueryMotifSample;
    let kButtons = [];
    const kButtonPrefix = 'background-bg-btn-';
    const kButtonParentPrefix = 'background-bg-parent-btn-';
    let kButtonIdx = 0;
    Object.keys(Constants.epilogosFimoBackgrounds).forEach(k => {
      const isActive = (activeBackground === k);
      const isDisabled = false;
      let kLabelDetail = Constants.epilogosFimoBackgrounds[k];
      let kLabel = k;
      const kValue = k;
      if (kValue === "sample") { kLabel += ` (${activeSample})`; }
      let kButtonKey = kButtonPrefix + kButtonIdx;
      let kButtonParentKey = kButtonParentPrefix + kButtonIdx;
      let formattedKLabel = <span style={{fontWeight:(isActive)?600:100,textTransform:"capitalize"}}>{kLabel}</span>;
      kButtons.push(<div key={kButtonParentKey}><input id={kButtonKey} key={kButtonKey} type="radio" checked={isActive} disabled={isDisabled} name="background" value={kValue} onChange={()=>{}} onClick={(e)=>{ this.setState({fimoQueryMotifBackground:e.target.value}) }} />{' '}<label className="form-label" htmlFor={kButtonKey} onMouseMove={(e)=>{this.fimoQueryModalShowTooltip(e, kLabelDetail)}} onMouseOut={(e)=>{this.fimoQueryModalHideTooltip()}}>{formattedKLabel}</label></div>);
      kButtonIdx++;
    });
    const kSectionBodyKey = 'background-sb';
    return <FormGroup key={kSectionBodyKey} check>{kButtons}</FormGroup>;
  };
  
  fimoQueryModalTable = () => {
    return (
      <div>
        <div style={{paddingBottom:"15px"}}>
          Search for <strong>Epilogo {(parseInt(this.state.fimoQueryMotifIdx) + 1)}</strong> positions in desired biosample:
        </div>
        <Table striped borderless>
          <tbody>
            <tr>
              <td className="fimo-query-modal-table-parameter fimo-query-modal-table-parameter-label">Assembly</td>
              <td className="fimo-query-modal-table-parameter fimo-query-modal-table-parameter-value">{ this.fimoQueryModalTableGenomeSectionBody() }</td>
            </tr>
            <tr>
              <td className="fimo-query-modal-table-parameter fimo-query-modal-table-parameter-label">Biosample</td>
              <td className="fimo-query-modal-table-parameter fimo-query-modal-table-parameter-value">
                <Input 
                  type="select" 
                  name="sample" 
                  value={this.state.fimoQueryMotifSample} 
                  onChange={(e) => { 
                    let newFimoQueryMotifSampleSimples = [...this.state.fimoQueryMotifSampleSimples];
                    newFimoQueryMotifSampleSimples[this.state.fimoQueryMotifIdx] = e.target.value;
                    this.setState({ 
                      fimoQueryMotifSample: e.target.value,
                      fimoQueryMotifSampleSimples: newFimoQueryMotifSampleSimples
                    }); 
                    document.activeElement.blur(); 
                  }}>{ this.fimoQueryModalTableSampleSectionBody(this.state.fimoQueryMotifGenome, this.state.fimoQueryMotifStateModel) }</Input>
              </td>
            </tr>
            <tr>
              <td className="fimo-query-modal-table-parameter fimo-query-modal-table-parameter-label">Background model</td>
              <td className="fimo-query-modal-table-parameter fimo-query-modal-table-parameter-value">
                { this.fimoQueryModalTableBackgroundSectionBody() }
                <div style={{fontSize:"0.8em", paddingTop:"10px"}}>
                  Match scores are calculated from the log-odds ratio of the probability of observing a sequence given the epilogo PWM to the probability of observing the same sequence given the selected background model
                </div>
              </td>
            </tr>
            <tr>
              <td className="fimo-query-modal-table-parameter fimo-query-modal-table-parameter-label"><em>P</em>-value threshold</td>
              <td className="fimo-query-modal-table-parameter fimo-query-modal-table-parameter-value">
                <DebounceInput 
                  className="fimo-query-modal-table-parameter-pValueThreshold-control"
                  name="fimoQueryMotifPvalueThreshold" 
                  value={ this.state.fimoQueryMotifPvalueThreshold } 
                  minLength={ 2 }
                  debounceTimeout={ 300 }
                  onChange={(e) => { this.setState({ fimoQueryMotifPvalueThreshold:e.target.value }); }} 
                  />
              </td>
            </tr>
          </tbody>
        </Table>
      </div>
    );
  }

  handleLocationsClick = (name) => {
    this.setState({
      currentLocationSelection: name
    }, () => {
      this.initializeLocationsInfiniteTableData();
      this.setState({
        locationsKey: Math.random()
      })
    });
  }
  
  flipOpenClose = (name) => {
    let newOpenCloseItemState = this.state.openClose[name];
    let newOpenClose = {...this.state.openClose, [name]:!newOpenCloseItemState};
    //console.log(JSON.stringify(newOpenClose));
    this.setState({
      openClose: newOpenClose
    });
  }
  
  downloadURI = (uri, name) => {
    let link = document.createElement("a");
    link.download = name;
    link.href = uri;
    link.style.display = "none";
    document.body.appendChild(link);
    if (typeof MouseEvent !== "undefined") {
      link.dispatchEvent(new MouseEvent("click"));
    } 
    else {
      link.click();
    }
    document.body.removeChild(link);
  }
  
  jumpToAnchor(a) {
    //const url = document.URL;
    const cleanURL = document.URL.split('#')[0];
    const newURL = `${cleanURL}#${a}`;
    window.location.replace(newURL);
  }
  
  handleAnchorClick = (o) => {
    //window.location.href = o.href;
    window.open(o.href, '_top');
  }
  
  reportNotReady = () => {
    return (
      <div>
        <div className="viewer-container-no-margin" ref="viewerContainer">
          <div style={{paddingLeft:"15px", paddingTop:"10px"}}>
            <span style={{fontSize:"0.9em", fontWeight:"400"}}><FaHome className="brand-content-text-viewer-home" onClick={(e)=>{window.location=Constants.epilogosMemeURL}} /> epilogos Search</span><br />
            <span style={{fontSize:"1.5em", fontWeight:"600"}}>Search results report</span>
          </div>
          <div style={{paddingLeft:"15px", paddingTop:"10px"}}>
            <div style={{paddingTop:"10px"}}>
              Analysis results are pending, while the computation job is being executed on our systems.
            </div>
            <div style={{paddingTop:"10px"}}>
              This page will automatically refresh once the Search results report is available, and you will receive an email at that same time (which will provide a link to the report page).
            </div>
          </div>
        </div>
      </div>
    );
  }
  
  jobSummary = () => {
    if (!document.getElementById('analysisSummary-table-card')) return;
    const cardWidth = document.getElementById('analysisSummary-table-card').offsetWidth;
    if (cardWidth < Constants.widthThreshold) {
      return (
        <div>
          <BootstrapTable 
            keyField='type' 
            data={this.jobSummaryLeftDataTable()}
            columns={this.jobSummaryColumns()} 
            bootstrap4={true} 
            bordered={false}
            classes="data-table"
            />
          <BootstrapTable 
            keyField='type' 
            data={this.jobSummaryRightDataTable()}
            columns={this.jobSummaryColumns()} 
            bootstrap4={true} 
            bordered={false}
            classes="data-table"
            />
        </div>
      )      
    }
    else {
      return (
        <div>
          <Container style={{}} className="remove-all-margin-padding">
            <Row>
              <Col xs="6">
                <BootstrapTable 
                  keyField='type' 
                  data={this.jobSummaryLeftDataTable()}
                  columns={this.jobSummaryColumns()} 
                  bootstrap4={true} 
                  bordered={false}
                  classes="data-table"
                  />
              </Col>
              <Col xs="6">
                <BootstrapTable 
                  keyField='type' 
                  data={this.jobSummaryRightDataTable()}
                  columns={this.jobSummaryColumns()} 
                  bootstrap4={true} 
                  bordered={false}
                  classes="data-table"
                  />
              </Col>
            </Row>
          </Container>
        </div>
      )
    }
  }
  
  jobSummaryRightDataTable = () => {
    const md = this.props.jobMetadata;
    let data = [];
    const jobSummaryDataTableRow = {
      'type' : "",
      'value' : ""
    };
    
    const background = Object.assign({}, jobSummaryDataTableRow);
    background.type = "Background model";
    background.value = `${Constants.epilogosMemeBackgrounds[md.background]}`;
    data.push(background);
    
    const siteDistribution = Object.assign({}, jobSummaryDataTableRow);
    siteDistribution.type = "Site distributions";
    siteDistribution.value = `${Constants.epilogosMemeMotifSiteDistributions[md.siteDistribution]}`;
    data.push(siteDistribution);
    
    const prior = Object.assign({}, jobSummaryDataTableRow);
    prior.type = "Prior";
    prior.value = `${Constants.epilogosMemePriors[md.prior]}`;
    data.push(prior);
    
    return data;
  }
  
  jobSummaryLeftDataTable = () => {
    const md = this.props.jobMetadata;
    //console.log("md", md);
    let data = [];
    const jobSummaryDataTableRow = {
      'type' : "",
      'value' : ""
    };
    
    const assembly = Object.assign({}, jobSummaryDataTableRow);
    assembly.type = "Assembly";
    assembly.value = `${md.genome} (${Constants.epilogosMemeGenomeSpecies[md.genome]})`;
    data.push(assembly);
    
    const model = Object.assign({}, jobSummaryDataTableRow);
    model.type = "State model";
    model.value = md.stateModel;
    data.push(model);
    
    const biosample = Object.assign({}, jobSummaryDataTableRow);
    biosample.type = "Epigenome sample";
    biosample.value = `${md.sample} (${Constants.epilogosMemeSamplesKV[md.genome][md.sample]})`;
    data.push(biosample);
    
    return data;
  }
  
  jobSummaryColumns = () => {
    const seqlogoWidth = this.state.seqlogoWidth;
    const typeWidth = "150px";
    //const valueWidth = ((seqlogoWidth/2) + 50) + "px";
    const columns = [
      {
        dataField: 'type',
        text: '',
        headerStyle: {
          maxHeight: '1px',
          height: '1px',
          width: typeWidth,
          minWidth: typeWidth,
          //borderBottom: '1px solid #b5b5b5',
        },
        style: {
          fontSize: '0.8em',
          fontWeight: 600,
          width: typeWidth,
          minWidth: typeWidth,
          outlineWidth: '0px',
          marginLeft: '4px',
          paddingTop: '3px',
          paddingBottom: '3px',
          textAlign: 'left',
        },
        sort: false
      },
      {
        dataField: 'value',
        text: '',
        headerStyle: {
          maxHeight: '1px',
          height: '1px',
          width: seqlogoWidth,
          borderBottom: '1px solid #b5b5b5',
        },
        style: {
          fontFamily: '"Consolas", "Input Mono", "Monaco", "Menlo", "Courier New", Courier, monospace',
          fontWeight: 'normal',
          fontSize: '0.8em',
          outlineWidth: '0px',
          paddingTop: '4px',
          paddingBottom: '3px',
          paddingRight: '2px',
          width: seqlogoWidth,
        },
        sort: false
      }
    ];
    return columns;
  }
  
  motifTable = () => {
    return (
      <div>
        <table id="motif-table">
          <tbody>
            {this.motifTableBodyRows()}
          </tbody>
        </table>
      </div>
    );
  }
  
  motifTableBodyRows = () => {
    if (this.props.memeMotifs.items.length === 0) 
      return;
    //let seqlogos = [];
    const seqlogoWidth = this.state.seqlogoWidth;
    const seqlogoLetterWidth = seqlogoWidth - 65;
    const seqlogoMode = "MEMEMotif";
    const seqlogoType = "epilogos";
    const seqlogoHeight = Constants.seqlogoHeight;
    const seqlogoLetterHeight = Constants.seqlogoLetterHeight;
    const seqlogoMargin = {
      top : 20,
      right : 0,
      bottom : 20,
      left: 15
    };
    const seqlogoMarginNoAxis = {
      top : 0,
      right : 0,
      bottom : 0,
      left: 0
    };
    
    /*
      These need to come from somewhere else in metadata — we'll use placeholders for now
    */
    const seqlogoEpilogosAssembly = this.props.assembly;
    const seqlogoEpilogosModel = this.props.model;
    
    //console.log("seqlogoEpilogosAssembly, seqlogoEpilogosModel", seqlogoEpilogosAssembly, seqlogoEpilogosModel);
        
    return this.props.memeMotifs.items.map((m, mi) => {
      const currentMotifIdx = this.state.currentMotifIdx;
      const motifIdx = mi + 1;
      const statisticsTableWidth = "240px";
      const seqlogoColorScheme = (seqlogoEpilogosAssembly === "mm10") ? "epilogos-15state-mouse" 
        : (this.props.memeMotifs.alphabet.length === 15) ? "epilogos-15state-human" 
        : (this.props.memeMotifs.alphabet.length === 18) ? "epilogos-18state-human" : "epilogos-25state-human";
      //console.log("seqlogoColorScheme", seqlogoColorScheme);
      const seqlogoItemText = m;
      const seqlogoId = `logo-${mi}`;
      const seqlogoTitle = "";
      //const seqlogoName = this.formattedMotifName(this.state.memeMotifs.attributes[mi].name);
      
      if (!document.getElementById('motif-table-card')) return;
      const cardWidth = document.getElementById('motif-table-card').offsetWidth;
      
      const remainingWidth = (document.getElementById('motif-table-card')) ? cardWidth - (parseInt(seqlogoWidth)) + 20 : 0;
      if (isNaN(remainingWidth)) return;
      
      function fimoHitsButton(idx, self) {
        return (
          <Button 
            /*disabled={self.state.fimoHitsButtonIsDisabled[idx] && (self.state.fimoQueryButtonStates[idx] !== "ready")}*/
            disabled={self.state.fimoHitsButtonIsDisabled[idx]}
            className="btn-results btn-xs" 
            color="link"
            style={{fontWeight:"500",color:"#173365"}} 
            name="resultsEpilogo" 
            data-id={"resultsEpilogo"}
            data-idx={idx}
            onClick={self.handleClick} >
            <div 
              name="resultsEpilogo" 
              data-id={"resultsEpilogo"}
              data-idx={idx}
              onClick={self.handleClick}><span onClick={(e) => { self.handleClick(e, {name:"resultsEpilogo", id:"resultsEpilogo", idx:idx}) }}><FaRegEye onClick={(e) => { self.handleClick(e, {name:"resultsEpilogo", id:"resultsEpilogo", idx:idx}) }} /> Previously searched results</span></div>
          </Button>
        )
      }
      
      function fimoSimpleSearchButton(idx, self) {
        return (
          <Button 
            disabled={self.state.fimoSimpleButtonIsDisabled[idx]}
            className="btn-download btn-xs btn-epilogos"
            color="primary"
            style={{marginTop:"10px"}} 
            name="simpleSearchEpilogo"
            data-id={"simpleSearchEpilogo"}
            data-idx={idx}
            onClick={self.handleClick} >
            Go
          </Button>
        );
      }
      
      function fimoReadyButton(idx, self) {
        return (
          <Button
            disabled={self.state.fimoReadyButtonIsDisabled[idx]}
            className="btn-download btn-xs" 
            color="link"
            style={{marginTop:"10px",color:"lightslategray"}}
            name="advancedSearchEpilogo" 
            data-id={"advancedSearchEpilogo"}
            data-idx={idx}
            onClick={self.handleClick}><FaCog onClick={(e) => { self.handleClick(e, {name:"advancedSearchEpilogo", id:"advancedSearchEpilogo", idx:idx}) }} />
          </Button>
        )
      }
      
      function fimoQueryingButton(idx, self) {
        return (
          <Button
            disabled
            className="btn-download btn-xs" 
            color="link"
            style={{marginTop:"10px",color:"lightslategray"}} 
            name="advancedSearchEpilogo" 
            data-id={"advancedSearchEpilogo"}
            data-idx={idx}>
            <Loader
              type="ThreeDots"
              color="#000000"
              height={14}
              width={14} />
          </Button>
        )
      }
      
      function fimoFailedButton(idx, self) {
        return (
          <Button
            className="btn-download btn-xs" 
            color="danger"
            style={{marginTop:"10px"}} 
            name="advancedSearchEpilogo" 
            data-id={"advancedSearchEpilogo"}
            data-idx={idx}>
            <FaCog /> {self.state.fimoQueryMotifFailureMessage}
          </Button>
        )
      }
      
      function epilogoDownloadCaret(idx, self) {
        /*
          delayHide={20000}
          delayUpdate={1000}
          <span 
            className="download-route-link" 
            key={`downloadEpilogosItem-${idx - 1}`}
            name="downloadEpilogosItem"
            data-id={`Epilogo-${(idx)}`}
            data-idx={(idx - 1)}
            ref={(thisButton) => {self.downloadItemButton = thisButton}}
            onClick={self.handleClick}
            >PWM</span>
          {"\u00a0"}|{"\u00a0"}
          <span 
            className="download-route-link" 
            name="downloadSVG" 
            data-id={"SVG"}
            data-idx={(idx - 1)}
            ref={(thisButton) => {self.downloadItemButton = thisButton}}
            onClick={self.handleClick}
            >SVG</span>
          -----
          <Button 
            style={{marginRight:"10px"}}
            className="btn-download btn-xs btn-epilogos" 
            color="primary" 
            key={`downloadEpilogosItem-${idx - 1}`}
            name="downloadEpilogosItem"
            data-id={`Epilogo-${(idx)}`}
            data-idx={(idx - 1)}
            ref={(thisButton) => {self.downloadItemButton = thisButton}}
            onClick={self.handleClick} >
            <FaDownload 
              onClick={(e) => {
                self.handleClick(e, {
                  'key': `downloadEpilogosItem-${idx - 1}`,
                  'name': 'downloadEpilogosItem',
                  'id': `Epilogo-${(idx)}`,
                  'idx': (idx - 1)
                });
              }} /> {`PWM (.txt)`}
          </Button>
          <Button 
            className="btn-download btn-xs btn-epilogos" 
            color="primary" 
            name="downloadSVG" 
            data-id={"SVG"}
            data-idx={(idx - 1)} 
            ref={(thisButton) => {self.downloadItemButton = thisButton}}
            onClick={self.handleClick} >
            <FaDownload 
              onClick={(e) => {
                self.handleClick(e, {
                  'name': 'downloadSVG',
                  'id': "SVG",
                  'idx': (idx - 1)
                });
              }} /> SVG
          </Button>
        */
        return (
          <div style={{display:"inline", zIndex:"1000", textAlign:"left", padding:"0px", margin:"0px", top:"35px"}}>
            <div className="per-epilogo-download-caret-parent">
              <a 
                title="Export options for discovered epilogo"
                data-for={`epilogoDownload-${idx}`} 
                data-tip={`${idx}`}
                data-event='click focus'>
                <span className="per-epilogo-download-caret"><FaDownload /></span>
              </a>
            </div>
            <ReactTooltip 
              globalEventOff='click'
              id={`epilogoDownload-${idx}`} 
              className="epilogo-download-caret"
              getContent={(dataTip) => 
                <div className="download-route-parent">
                  <div className="download-route-label">export</div>
                  <span 
                    title="Position weight matrix (.txt)"
                    className="download-route-link" 
                    key={`downloadEpilogosItem-${idx - 1}`}
                    name="downloadEpilogosItem"
                    data-id={`Epilogo-${(idx)}`}
                    data-idx={(idx - 1)}
                    ref={(thisButton) => {self.downloadItemButton = thisButton}}
                    onClick={(e) => { 
                      self.handleClick(e, {
                        'key': `downloadEpilogosItem-${idx - 1}`,
                        'name': 'downloadEpilogosItem',
                        'id': `Epilogo-${(idx)}`,
                        'idx': (idx - 1)
                      });
                    }}
                    >PWM</span>
                  {"\u00a0"}|{"\u00a0"}
                  <span 
                    title="Vector-formatted epilogo (.svg)"
                    className="download-route-link" 
                    name="downloadSVG" 
                    data-id={"SVG"}
                    data-idx={(idx - 1)}
                    ref={(thisButton) => {self.downloadItemButton = thisButton}}
                    onClick={(e) => {
                      self.handleClick(e, {
                        'name': 'downloadSVG',
                        'id': "SVG",
                        'idx': (idx - 1)
                      });
                    }}
                    >SVG</span>
                </div> 
              }
              effect='solid'
              clickable={true}
              place={'right'}
              border={true}
              type={'light'}
            />
          </div>
        )
      }
      
      if (cardWidth < Constants.widthThreshold) {
        const modifiedSeqlogoWidth = cardWidth - 80;
        const modifiedSeqlogoLetterWidth = modifiedSeqlogoWidth - 65;
        return (
          <tr key={`motif-row-${motifIdx}`} style={{cursor:"pointer"}} onClick={()=>{this.changeCurrentMotifIdx(mi);}}>
            <td style={{width:modifiedSeqlogoWidth, verticalAlign:"center", textAlign:"center", borderBottomWidth:(this.props.memeMotifs.items.length > motifIdx) ? "1px" : "0px", borderBottomColor:(this.props.memeMotifs.items.length > motifIdx) ? "rgba(127,127,127,1)" : "rgba(0,0,0,0)", borderBottomStyle:"dotted", paddingTop:(motifIdx > 1) ? "15px" : "0px", paddingBottom:(motifIdx < this.props.memeMotifs.items.length) ? "15px" : "0px"}}>
              <div>
                <span style={{fontSize:"1.3em", letterSpacing:"0.7px", fontWeight:"500", cursor:"default"}}>{`Epilogo ${motifIdx}`}</span>{" "}{epilogoDownloadCaret(motifIdx, this)}
              </div>
              <SequenceLogo
                motifKey={this.state.motifKey}
                id={seqlogoId}
                title={seqlogoTitle}
                mode={seqlogoMode}
                colorScheme={seqlogoColorScheme}
                item={seqlogoItemText}
                type={seqlogoType}
                svgWidth={modifiedSeqlogoWidth}
                svgHeight={seqlogoHeight}
                svgMargin={seqlogoMargin}
                svgLetterWidth={modifiedSeqlogoLetterWidth}
                svgLetterHeight={seqlogoLetterHeight}
                epilogosAssembly={seqlogoEpilogosAssembly}
                epilogosModel={seqlogoEpilogosModel}
                yAxisVisible={true}
                xAxisVisible={true}
              />
              <div style={{width:modifiedSeqlogoWidth,cursor:"default"}}>
                <span style={{fontSize:"0.8em",fontWeight:"600"}}>E-value</span> <span style={{fontSize:"0.8em",fontWeight:"normal",fontFamily:'"Consolas", "Input Mono", "Monaco", "Menlo", "Courier New", Courier, monospace',cursor:"text"}}>{this.props.memeMotifs.attributes[mi].e_value}</span> | <span style={{fontSize:"0.8em",fontWeight:"600"}}>Sites</span> <span style={{fontSize:"0.8em",fontWeight:"normal",fontFamily:'"Consolas", "Input Mono", "Monaco", "Menlo", "Courier New", Courier, monospace',cursor:"text"}}>{this.props.memeMotifs.attributes[mi].sites}</span> | <span style={{fontSize:"0.8em",fontWeight:"600"}}>Width</span> <span style={{fontSize:"0.8em",fontWeight:"normal",fontFamily:'"Consolas", "Input Mono", "Monaco", "Menlo", "Courier New", Courier, monospace',cursor:"text"}}>{`${this.props.memeMotifs.attributes[mi].width * Constants.epilogosMemeChromatinStateCallIntervalWidth} nt`}</span>
              </div>
              <form className="navbar-form navbar-right" role="button" style={{paddingTop:"10px"}}>
                
                <div>
                  <span>
                    <span className="fimo-simple-search-label">
                      <span style={{cursor:"default"}}>Search for <strong>{`Epilogo ${(mi + 1)}`}</strong> in biosample&nbsp;</span>
                      <Input 
                        disabled={this.state.fimoSimpleButtonIsDisabled[mi]}
                        type="select" 
                        name="sample" 
                        style={{display:"unset",width:"55px",height:"calc(1.5em + 2px)",padding:"unset",position:"relative",top:"-1px",cursor:"pointer"}}
                        value={this.state.fimoQueryMotifSampleSimples && this.state.fimoQueryMotifSampleSimples[mi]} 
                        data-idx={mi}
                        onChange={(e) => { 
                          let newFimoQueryMotifSampleSimples = [];
                          let newSample = e.target.value;
                          let idx = e.target.dataset.idx;
                          newFimoQueryMotifSampleSimples[idx] = newSample;
                          this.setState({ 
                            fimoQueryMotifSample: newSample,
                            fimoQueryMotifSampleSimples: newFimoQueryMotifSampleSimples
                          });
                          document.activeElement.blur(); 
                        }}>{ this.fimoQueryModalTableSampleSectionBody(this.state.fimoQueryMotifGenome, this.state.fimoQueryMotifStateModel) }
                      </Input>
                      &nbsp;&nbsp;&nbsp;
                    </span>
                    { fimoSimpleSearchButton(mi, this) }
                    <span>{ (this.state.fimoQueryButtonStates[mi] === "ready") ? fimoReadyButton(mi, this) : (this.state.fimoQueryButtonStates[mi] === "failed") ? fimoFailedButton(mi, this) : fimoQueryingButton(mi, this) }</span>
                  </span>
                </div>
                
                <div>{ fimoHitsButton(mi, this) }</div>
                
                {/* <div>{ (this.state.fimoQueryMotifDataAvailable[mi]) ? fimoHitsButton(mi, this) : "" }</div> */}
                {/*
                <span>
                  <Button 
                    style={{marginRight:"10px"}}
                    className="btn-download btn-xs" 
                    color="primary" 
                    key={`downloadEpilogosItem-${mi}`}
                    name="downloadEpilogosItem"
                    data-id={`Epilogo-${(mi + 1)}`}
                    data-idx={mi}
                    ref={(thisButton) => {this.downloadItemButton = thisButton}}
                    onClick={this.handleClick} >
                    <FaDownload /> {`PWM (.txt)`}
                  </Button>
                  <Button 
                    className="btn-download btn-xs" 
                    color="primary" 
                    name="downloadSVG" 
                    data-id={"SVG"}
                    data-idx={mi} 
                    onClick={this.handleClick} >
                    <FaDownload /> SVG
                  </Button>
                </span>
                */}
              </form>
              <div id={seqlogoId + "-noaxis-parent"} style={{position:"absolute",top:"-10000px"}}>
                <SequenceLogo
                  motifKey={this.state.motifKey}
                  id={seqlogoId + "-noaxis"}
                  title={seqlogoTitle}
                  mode={seqlogoMode}
                  colorScheme={seqlogoColorScheme}
                  item={seqlogoItemText}
                  type={seqlogoType}
                  svgWidth={seqlogoWidth}
                  svgHeight={seqlogoHeight}
                  svgMargin={seqlogoMarginNoAxis}
                  svgLetterWidth={seqlogoWidth}
                  svgLetterHeight={seqlogoLetterHeight}
                  epilogosAssembly={seqlogoEpilogosAssembly}
                  epilogosModel={seqlogoEpilogosModel}
                  yAxisVisible={false}
                  xAxisVisible={false}
                />
              </div>
              <div style={{paddingTop:"30px", paddingBottom:"20px"}}>{this.sitesInfiniteTable(mi, cardWidth - 40, cardWidth - 40)}</div>
            </td>
          </tr>
        );
      }
      else {
        return (
          <tr key={`motif-row-${motifIdx}`} style={{cursor:"pointer"}} onClick={()=>{this.changeCurrentMotifIdx(mi);}}>
            <td style={{width:seqlogoWidth, verticalAlign:"center", textAlign:"center", borderBottomWidth:(this.props.memeMotifs.items.length > motifIdx) ? "1px" : "0px", borderBottomColor:(this.props.memeMotifs.items.length > motifIdx) ? "rgba(127,127,127,1)" : "rgba(0,0,0,0)", borderBottomStyle:"dotted", paddingTop:(motifIdx > 1) ? "15px" : "0px", paddingBottom:(motifIdx < this.props.memeMotifs.items.length) ? "15px" : "0px"}}>
              <div>
                <span style={{fontSize:"1.3em", letterSpacing:"0.7px", fontWeight:"500", cursor:"default"}}>{`Epilogo ${motifIdx}`}</span>{" "}{epilogoDownloadCaret(motifIdx, this)}
              </div>
              <SequenceLogo
                motifKey={this.state.motifKey}
                id={seqlogoId}
                title={seqlogoTitle}
                mode={seqlogoMode}
                colorScheme={seqlogoColorScheme}
                item={seqlogoItemText}
                type={seqlogoType}
                svgWidth={seqlogoWidth}
                svgHeight={seqlogoHeight}
                svgMargin={seqlogoMargin}
                svgLetterWidth={seqlogoLetterWidth}
                svgLetterHeight={seqlogoLetterHeight}
                epilogosAssembly={seqlogoEpilogosAssembly}
                epilogosModel={seqlogoEpilogosModel}
                yAxisVisible={true}
                xAxisVisible={true}
              />
              <div style={{position:"flex",cursor:"default"}}>
                <span style={{fontSize:"0.8em",fontWeight:"600"}}>E-value</span> <span style={{fontSize:"0.8em",fontWeight:"normal",fontFamily:'"Consolas", "Input Mono", "Monaco", "Menlo", "Courier New", Courier, monospace',cursor:"text"}}>{this.props.memeMotifs.attributes[mi].e_value}</span> | <span style={{fontSize:"0.8em",fontWeight:"600"}}>Sites</span> <span style={{fontSize:"0.8em",fontWeight:"normal",fontFamily:'"Consolas", "Input Mono", "Monaco", "Menlo", "Courier New", Courier, monospace',cursor:"text"}}>{this.props.memeMotifs.attributes[mi].sites}</span> | <span style={{fontSize:"0.8em",fontWeight:"600"}}>Width</span> <span style={{fontSize:"0.8em",fontWeight:"normal",fontFamily:'"Consolas", "Input Mono", "Monaco", "Menlo", "Courier New", Courier, monospace',cursor:"text"}}>{`${this.props.memeMotifs.attributes[mi].width * Constants.epilogosMemeChromatinStateCallIntervalWidth} nt`}</span>
              </div>
              <form className="navbar-form navbar-right" role="button" style={{paddingTop:"10px"}}>
                <div>          
                  <span>
                    <span className="fimo-simple-search-label">
                      <span style={{cursor:"default"}}>Search for <strong>{`Epilogo ${(mi + 1)}`}</strong> in biosample&nbsp;</span>
                      <Input 
                        disabled={this.state.fimoSimpleButtonIsDisabled[mi]}
                        type="select" 
                        name="sample" 
                        style={{display:"unset",width:"55px",height:"calc(1.5em + 2px)",padding:"unset",position:"relative",top:"-1px",cursor:"pointer"}}
                        value={this.state.fimoQueryMotifSampleSimples && this.state.fimoQueryMotifSampleSimples[mi]} 
                        data-idx={mi}
                        onChange={(e) => { 
                          let newFimoQueryMotifSampleSimples = [];
                          let newSample = e.target.value;
                          let idx = e.target.dataset.idx;
                          newFimoQueryMotifSampleSimples[idx] = newSample;
                          this.setState({ 
                            fimoQueryMotifSample: newSample,
                            fimoQueryMotifSampleSimples: newFimoQueryMotifSampleSimples
                          });
                          document.activeElement.blur(); 
                        }}>{ this.fimoQueryModalTableSampleSectionBody(this.state.fimoQueryMotifGenome, this.state.fimoQueryMotifStateModel) }
                      </Input>
                      &nbsp;&nbsp;&nbsp;
                    </span>
                    { fimoSimpleSearchButton(mi, this) }
                    <span>{ (this.state.fimoQueryButtonStates[mi] === "ready") ? fimoReadyButton(mi, this) : (this.state.fimoQueryButtonStates[mi] === "failed") ? fimoFailedButton(mi, this) : fimoQueryingButton(mi, this) }</span>
                  </span>
                </div>
                
                <div>{ fimoHitsButton(mi, this) }</div>
                
                {/* <div>{ (this.state.fimoQueryMotifDataAvailable[mi]) ? fimoHitsButton(mi, this) : "" }</div> */}
                {/*
                <span>
                  <Button 
                    style={{marginRight:"10px"}}
                    className="btn-download btn-xs" 
                    color="primary" 
                    key={`downloadEpilogosItem-${mi}`}
                    name="downloadEpilogosItem"
                    data-id={`Epilogo-${(mi + 1)}`}
                    data-idx={mi}
                    ref={(thisButton) => {this.downloadItemButton = thisButton}}
                    onClick={this.handleClick} >
                    <FaDownload /> {`PWM (.txt)`}
                  </Button>
                  <Button 
                    className="btn-download btn-xs" 
                    color="primary" 
                    name="downloadSVG" 
                    data-id={"SVG"}
                    data-idx={mi} 
                    onClick={this.handleClick} >
                    <FaDownload /> SVG
                  </Button>
                </span>
                */}
              </form>
              <div id={seqlogoId + "-noaxis-parent"} style={{position:"absolute",top:"-10000px"}}>
                <SequenceLogo
                  motifKey={this.state.motifKey}
                  id={seqlogoId + "-noaxis"}
                  title={seqlogoTitle}
                  mode={seqlogoMode}
                  colorScheme={seqlogoColorScheme}
                  item={seqlogoItemText}
                  type={seqlogoType}
                  svgWidth={seqlogoWidth}
                  svgHeight={seqlogoHeight}
                  svgMargin={seqlogoMarginNoAxis}
                  svgLetterWidth={seqlogoWidth}
                  svgLetterHeight={seqlogoLetterHeight}
                  epilogosAssembly={seqlogoEpilogosAssembly}
                  epilogosModel={seqlogoEpilogosModel}
                  yAxisVisible={false}
                  xAxisVisible={false}
                />
              </div>
            </td>
            <td style={{width:remainingWidth, verticalAlign:"center", borderBottomWidth:(this.props.memeMotifs.items.length > motifIdx) ? "1px" : "0px", borderBottomColor:(this.props.memeMotifs.items.length > motifIdx) ? "rgba(127,127,127,1)" : "rgba(0,0,0,0)", borderBottomStyle:"dotted", paddingTop:(motifIdx > 1) ? "15px" : "0px", paddingBottom:(motifIdx < this.props.memeMotifs.items.length) ? "15px" : "0px"}}>
              {this.sitesInfiniteTable(mi, remainingWidth - 80, cardWidth)}
            </td>
          </tr>
        );
      }
    });
  }
  
  initializeFimoQueryButtonStates = () => {
    if (!this.props.memeMotifs) return;
    if (!this.props.jobMetadata) return;
    let fimoQueryButtonStates = [];
    let fimoQueryMotifSampleSimples = [];
    for (let motifIdx = 0; motifIdx < this.props.memeMotifs.items.length; motifIdx++) {
      fimoQueryButtonStates[motifIdx] = "ready";
      fimoQueryMotifSampleSimples[motifIdx] = this.props.jobMetadata.sample;
    }
    this.setState({
      fimoQueryButtonStates: fimoQueryButtonStates,
      fimoQueryMotifGenome: this.props.jobMetadata.genome,
      fimoQueryMotifSample: this.props.jobMetadata.sample,
      fimoQueryMotifSampleSimples: fimoQueryMotifSampleSimples,
      fimoQueryMotifStateModel: this.props.jobMetadata.stateModel,
      fimoQueryMotifMEMEVersion: this.props.jobMetadata.memeVersion,
      fimoQueryMotifResultsDirectory: this.props.jobMetadata.results_dir,
      fimoQueryMotifEmail: this.props.jobMetadata.email
    });
  }
  
  initializeSitesInfiniteTableData = () => {
    let initialSitesKeys = [];
    let initialTableData = [];
    let initialTableDataOffsets = [];
    let initialTableDataHasMoreData = [];
    if (!this.props.memeMotifs) return;
    for (let motifIdx = 0; motifIdx < this.props.memeMotifs.sites.length; motifIdx++) {
      const sites = this.props.memeMotifs.sites[motifIdx].slice(0, this.state.sitesInfiniteTableDataInitialChunk);
      initialTableData.push(sites);
      initialTableDataOffsets.push(this.state.sitesInfiniteTableDataInitialChunk);
      initialTableDataHasMoreData.push(true);
      initialSitesKeys[motifIdx] = 0;
    }
    this.setState({
      sitesKeys: initialSitesKeys,
      sitesInfiniteTableData: initialTableData,
      sitesInfiniteTableDataOffsets: initialTableDataOffsets,
      sitesInfiniteTableHasMoreData: initialTableDataHasMoreData
    });
  }
  
  fetchMoreSitesInfiniteTableData = (i) => {
    //console.log(`fetchMoreSitesInfiniteTableData started for ${i}`);
    const motifIdx = i;
    const sitesInfiniteTableData = this.state.sitesInfiniteTableData;
    const sitesInfiniteTableDataOffsets = this.state.sitesInfiniteTableDataOffsets;
    const sitesInfiniteTableDataHasMoreData = this.state.sitesInfiniteTableHasMoreData;

    const oldSitesInfiniteTableDataOffsetsForMotif = sitesInfiniteTableDataOffsets[motifIdx];
    let newSitesInfiniteTableDataOffsetForMotif = sitesInfiniteTableDataOffsets[motifIdx] + this.state.sitesInfiniteTableDataChunk;
    
    //console.log("mid newSitesInfiniteTableDataOffsetForMotif", newSitesInfiniteTableDataOffsetForMotif);
    //console.log("sitesInfiniteTableData[motifIdx]", JSON.stringify(sitesInfiniteTableData[motifIdx], null, 2));
    
    sitesInfiniteTableDataHasMoreData[i] = newSitesInfiniteTableDataOffsetForMotif <= this.props.memeMotifs.sites[i].length;
    
    if (newSitesInfiniteTableDataOffsetForMotif > this.props.memeMotifs.sites[motifIdx].length) {
      newSitesInfiniteTableDataOffsetForMotif = this.props.memeMotifs.sites[motifIdx].length;
    }
    
    const newSitesInfiniteTableDataForMotif = sitesInfiniteTableData[motifIdx].concat(this.props.memeMotifs.sites[motifIdx].slice(oldSitesInfiniteTableDataOffsetsForMotif, newSitesInfiniteTableDataOffsetForMotif));
    sitesInfiniteTableData[motifIdx] = newSitesInfiniteTableDataForMotif;
    sitesInfiniteTableDataOffsets[motifIdx] = newSitesInfiniteTableDataOffsetForMotif;
    
    setTimeout(() => {
      this.setState({
        sitesInfiniteTableData: sitesInfiniteTableData,
        sitesInfiniteTableDataOffsets: sitesInfiniteTableDataOffsets,
        sitesInfiniteTableHasMoreData: sitesInfiniteTableDataHasMoreData
      });
    }, 500);
  }
  
  resetSitesInfiniteTableData = () => {
    let resetSitesTableData = false;
    const sitesKeys = this.state.sitesKeys;
    const sitesInfiniteTableData = this.state.sitesInfiniteTableData;
    const sitesInfiniteTableDataOffsets = this.state.sitesInfiniteTableDataOffsets;
    const sitesInfiniteTableDataHasMoreData = this.state.sitesInfiniteTableHasMoreData;
    for (let motifIdx = 0; motifIdx < this.props.memeMotifs.sites.length; motifIdx++) {
      if (this.state.sitesInfiniteTableDataOffsets[motifIdx] > this.state.sitesInfiniteTableDataInitialChunk) {
        resetSitesTableData = true;
        sitesInfiniteTableData[motifIdx] = this.props.memeMotifs.sites[motifIdx].slice(0, this.state.sitesInfiniteTableDataInitialChunk);
        sitesInfiniteTableDataOffsets[motifIdx] = this.state.sitesInfiniteTableDataInitialChunk;
        sitesInfiniteTableDataHasMoreData[motifIdx] = this.state.sitesInfiniteTableDataInitialChunk <= this.props.memeMotifs.sites[motifIdx].length;
        sitesKeys[motifIdx] = this.state.sitesKeys[motifIdx] + 1;
      }
    }
    if (resetSitesTableData) {
      this.setState({
        sitesKeys: sitesKeys,
        sitesInfiniteTableData: sitesInfiniteTableData,
        sitesInfiniteTableDataOffsets: sitesInfiniteTableDataOffsets,
        sitesInfiniteTableHasMoreData: sitesInfiniteTableDataHasMoreData,
        
      })
    }
  }
  
  sitesInfiniteTable = (i, w, cardWidth) => {
    const motifIdx = i;    
    const sites = this.state.sitesInfiniteTableData[motifIdx];
    if ((!sites) || (sites.length === 0))
      return;
    //console.log("sitesInfiniteTable > sites", sites);
    
    const rowStyle = {
      fontSize: '0.7em',
      // minWidth: w,
      // maxWidth: w,
      // display: "flex",
      scrollbarWidth: "none",
      overflowX: "hidden",
    };
    
    const headerStyle = {
      fontSize: '0.7em',
      fontWeight: 600,
      // minWidth: w,
      // maxWidth: w,
      // display: "flex",
      fontFamily: '".SFNSDisplay-Regular", -apple-system, BlinkMacSystemFont, "Helvetica Neue", "Helvetica", "Calibri", sans-serif',
      marginBottom: "2px",
      scrollbarWidth: "none",
      overflowX: "hidden",
    }
    
    const sitesText = document.createElement("span");
    document.body.appendChild(sitesText);
    sitesText.style.font = '"Consolas", "Input Mono", "Monaco", "Menlo", "Courier New", Courier, monospace';
    sitesText.style.fontSize = "0.7em"; 
    sitesText.style.fontWeight = "300";
    sitesText.style.letterSpacing = "-0.001em";
    sitesText.style.height = 'auto'; 
    sitesText.style.width = 'auto'; 
    sitesText.style.position = 'absolute'; 
    sitesText.style.whiteSpace = 'no-wrap'; 
    sitesText.innerHTML = ReactDOMServer.renderToString(this.formattedMotifName(sites[0].sites, 0, "spacer", "left", sites[0].sites.length));
    const rawSitesGlyphWidth = sitesText.clientWidth / sites[0].sites.length;
    const sitesTextWidth = Math.ceil(sitesText.clientWidth) * 0.623870967741935;
    document.body.removeChild(sitesText);
    
    const longestLeftFlankLength = sites.reduce((a, b) => { return a.left_flank.length > b.left_flank.length ? a : b; }).left_flank.length;
    const longestRightFlankLength = sites.reduce((a, b) => { return a.right_flank.length > b.right_flank.length ? a : b; }).right_flank.length;
    const sitesTextLength = sites[0].sites.length;
    const totalChromatinStateWidth = parseInt(parseFloat(rawSitesGlyphWidth) * ((longestLeftFlankLength + longestRightFlankLength + sitesTextLength) * 0.7364));
    
/*
    console.log("i", i);
    console.log("w", w);
    console.log("parseFloat(rawSitesGlyphWidth)", parseFloat(rawSitesGlyphWidth));
    console.log("(longestLeftFlankLength + longestRightFlankLength + sitesTextWidth)", (longestLeftFlankLength + longestRightFlankLength + sitesTextLength));
    console.log("totalChromatinStateWidth", totalChromatinStateWidth);
*/
    
    const indexWidth = 60;
    const sequenceIndexWidth = 40;
    const strandWidth = 20;
    const startWidth = 60;
    const pValueWidth = 80;
    
    const firstThird = parseFloat(cardWidth / 3);
    const middleThird = firstThird * 2;
    const lastThird = cardWidth;
    
    //const allowedWidth = parseInt(0.33 * w);
    
    const allowedWidth = w - (totalChromatinStateWidth + indexWidth + sequenceIndexWidth + strandWidth + startWidth + pValueWidth) - 40;
    //console.log("allowedWidth", allowedWidth);
    const allowedGlyphs = parseInt(allowedWidth * 1.7 / rawSitesGlyphWidth);
    //console.log("allowedGlyphs", allowedGlyphs);
    function shortenedSequenceName(seqName) {
      //const seqNameTextLength = rawSitesGlyphWidth * seqName.length;
      //console.log("seqName", seqName, seqName.length, rawSitesGlyphWidth, seqNameTextLength, seqName.visualLength());
      //return (seqNameTextLength > allowedWidth) ? seqName.substr(0, allowedGlyphs) + "…" : seqName;
      return (seqName.visualLength() > allowedWidth) ? seqName.substr(0, allowedGlyphs) + "…" : seqName;
    }
    const align = "left";
    
    return (
      <div key={this.state.sitesKeys[i]}>
        <div style={headerStyle}>
          <div className="sites-row-header" id={`sites-${i}-header`} onScroll={(e)=>{if (!e) return; let element = e.target; document.getElementsByClassName(`sites-${i}-body`)[0].scrollLeft=element.scrollLeft;}}>
            <div className="sites-row-header-cell sites-row-cell-index" style={{verticalAlign:"middle"}}>&nbsp;</div>
            <div className="sites-row-header-cell sites-row-cell-sequence_index" style={{verticalAlign:"middle"}}>&nbsp;</div>
            <div className="sites-row-header-cell sites-row-cell-sequence_name" style={cardWidth>=1200?{verticalAlign:"middle",width:allowedWidth}:{display:"none"}}>Sequence</div>
            <div className="sites-row-header-cell sites-row-cell-strand" style={{verticalAlign:"middle"}}>&nbsp;</div>
            <div className="sites-row-header-cell sites-row-cell-start" style={{verticalAlign:"middle"}}>Start (nt)</div>
            <div className="sites-row-header-cell sites-row-cell-pvalue" style={{verticalAlign:"middle", textAlign:"center"}}><em>p</em>-Value</div>
            <div className="sites-row-cell sites-row-cell-sites-data sites-row-cell-left_flank" style={{fontFamily: '"Consolas", "Input Mono", "Monaco", "Menlo", "Courier New", Courier, monospace'}}>{this.formattedMotifName(sites[0].sites, 0, "spacer", "left", longestLeftFlankLength)}</div>
            <div className="sites-row-header-cell sites-row-cell-sites-data sites-row-cell-sites" style={{verticalAlign:"middle", textAlign:"center", width:sitesTextWidth}}>Chromatin states</div>
            <div className="sites-row-cell sites-row-cell-sites-data sites-row-cell-right_flank" style={{fontFamily: '"Consolas", "Input Mono", "Monaco", "Menlo", "Courier New", Courier, monospace'}}>{this.formattedMotifName(sites[0].sites, 0, "spacer", "left", longestRightFlankLength)}</div>
          </div>
        </div>
        <div id={`sis-${i}`} style={{height:"340px",overflow:"auto"}}>
          <div>
            <InfiniteScroll
              dataLength={sites.length}
              next={() => this.fetchMoreSitesInfiniteTableData(i)}            
              hasMore={this.state.sitesInfiniteTableHasMoreData[i]}
              loader={<div className="loader" key={`sites-${i}-is`}>Loading sequences...</div>}
              endMessage={<div className="end-message">No more sequences</div>}
              className={`sites-${i}-body`}
              style={{scrollbarWidth:"none",overflowX:"hidden"}}
              scrollThreshold={1}
              scrollableTarget={`sis-${i}`}
              onScroll={(e)=>{if (!e) return; let element = e.target; document.getElementById(`sites-${i}-header`).scrollLeft=element.scrollLeft;}}
              >
              {
                sites.map((s, si) => {
                  const indexOfChrInSequenceName = s.sequence_name.indexOf("chr");
                  const sequenceWithoutSeqPrefix = s.sequence_name.substr(indexOfChrInSequenceName);
                  return (
                    <div style={rowStyle} key={`${i}-${si}`}>
                      <div className="sites-row">
                        <div className="sites-row-cell sites-row-cell-index" style={{verticalAlign:"middle"}}>{si + 1}</div>
                        <div 
                          className="sites-row-cell sites-row-cell-sequence_index" 
                          style={{verticalAlign:"middle"}}
    /*
                          onMouseMove ={(e) => {
                            const tooltip = document.getElementById("view-container-tooltip");
                            tooltip.innerHTML = `${s.sequence_name}`;
                            tooltip.style.display = "block";
                            const rect = tooltip.getBoundingClientRect();
                            const trueAlign = (e.pageX < firstThird) ? "left" : (e.pageX < middleThird) ? "middle" : "right";
                            if (trueAlign === "left") {
                              tooltip.style.left = e.pageX - 5 - rect.width + 'px';
                              tooltip.style.top = e.pageY - 5 - rect.height + 'px';
                            }
                            else if (trueAlign === "middle") {
                              tooltip.style.left = e.pageX - (rect.width/2) + 'px';
                              tooltip.style.top = e.pageY - 5 - rect.height + 'px';
                            }
                            else if (trueAlign === "right") {
                              tooltip.style.left = e.pageX + 10 + 'px';
                              tooltip.style.top = e.pageY - 5 - rect.height + 'px';              
                            }
                          }}
                          onMouseOut={(e) => {
                            const tooltip = document.getElementById("view-container-tooltip");
                            tooltip.style.display = "none";
                          }}
    */
                          ><Badge color="secondary" pill>{s.sequence_index + 1}</Badge></div>
                        <div
                          className="sites-row-cell sites-row-cell-sequence_name"
                          style={cardWidth>=1200?{verticalAlign:"middle",width:allowedWidth}:{display:"none"}} 
    /*
                          onMouseMove ={(e) => {
                            const tooltip = document.getElementById("view-container-tooltip");
                            tooltip.innerHTML = `${sequenceWithoutSeqPrefix}`;
                            tooltip.style.display = "block";
                            const rect = tooltip.getBoundingClientRect();
                            const trueAlign = (e.pageX < firstThird) ? "left" : (e.pageX < middleThird) ? "middle" : "right";
                            if (trueAlign === "left") {
                              tooltip.style.left = e.pageX - 5 - rect.width + 'px';
                              tooltip.style.top = e.pageY - 5 - rect.height + 'px';
                            }
                            else if (trueAlign === "middle") {
                              tooltip.style.left = e.pageX - (rect.width/2) + 'px';
                              tooltip.style.top = e.pageY - 5 - rect.height + 'px';
                            }
                            else if (trueAlign === "right") {
                              tooltip.style.left = e.pageX + 10 + 'px';
                              tooltip.style.top = e.pageY - 5 - rect.height + 'px';              
                            }
                          }}
                          onMouseOut={(e) => {
                            const tooltip = document.getElementById("view-container-tooltip");
                            tooltip.style.display = "none";
                          }}
    */
                          >{shortenedSequenceName(sequenceWithoutSeqPrefix)}</div>
                        <div className="sites-row-cell sites-row-cell-strand" style={{verticalAlign:"middle"}}>{(s.strand === "plus") ? "+" : "-"}</div>
                        <div className="sites-row-cell sites-row-cell-start" style={{verticalAlign:"middle"}}>{parseInt(s.position) * Constants.epilogosMemeChromatinStateCallIntervalWidth}</div>
                        <div className="sites-row-cell sites-row-cell-pvalue" style={{verticalAlign:"middle"}}>{s.p_value}</div>
                        <div className="sites-row-cell sites-row-cell-sites-data sites-row-cell-left_flank" style={{verticalAlign:"middle"}}>{this.formattedMotifName(s.left_flank, 0.35, "left_flank", "left", longestLeftFlankLength)}</div>
                        <div className="sites-row-cell sites-row-cell-sites-data sites-row-cell-sites" style={{verticalAlign:"middle"}}>{this.formattedMotifName(s.sites, 1.0, "center", "left", s.sites.length)}</div>
                        <div className="sites-row-cell sites-row-cell-sites-data sites-row-cell-right_flank" style={{verticalAlign:"middle"}}>{this.formattedMotifName(s.right_flank, 0.35, "right_flank", "left", longestRightFlankLength)}</div>
                      </div>
                    </div>
                  );
                })
              }
            </InfiniteScroll>
          </div>
        </div>
      </div>
    )
  }

  formattedMotifName = (name, opacity, category, align, minLength) => {
    if (typeof opacity === "undefined") opacity = 1;
    if (typeof align === "undefined") align = "left";
    function hexToRgb(hex) {
      const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
      } : null;
    }
    if (category === "left_flank") {
      name = name.padStart(minLength, "-");
    }
    else if (category === "right_flank") {
      name = name.padEnd(minLength, "-");
    }
    else if (category === "spacer") {
      name = "-".repeat(minLength);
    }
    return name.split('').map((l, li) => {
      if (l !== "-") {
        const rgb = hexToRgb(Constants.colormap[this.props.assembly][this.props.model][l]);
        const color = `rgba(${rgb.r},${rgb.g},${rgb.b},${opacity})`;
        return (
          <span 
            key={`${category}-${l}-${li}`} 
            className="formatted-motif-name-element"
            onMouseMove={(e) => {
              const description = Constants.epilogosLetterToState(this.props.assembly, this.props.model, l);
              const tooltip = document.getElementById("view-container-tooltip");
              const section = (category === "left_flank") ? " | Left flank" : (category === "right_flank") ? " | Right flank" : (category === "center") ? " | Motif" : "";
              tooltip.innerHTML = `${description}${section}`;
              tooltip.style.display = "block";
              const rect = tooltip.getBoundingClientRect();
              //console.log("align");
              if (align === "left") {
                tooltip.style.left = e.pageX - 5 - rect.width + 'px';
                tooltip.style.top = e.pageY - 5 - rect.height + 'px';
              }
              else if (align === "right") {
                tooltip.style.left = e.pageX + 10 + 'px';
                tooltip.style.top = e.pageY - 5 - rect.height + 'px';              
              }
            }} 
            onMouseOut={(e) => {
              const tooltip = document.getElementById("view-container-tooltip");
              tooltip.style.display = "none";
            }}
            style={{cursor:'pointer', color:color}}>
            &#x2588;
          </span>
        );
      }
      else {
        return (
          <span 
            key={`${category}-${l}-${li}`} 
            className="formatted-motif-name-element"
            style={{color:"rgba(0,0,0,0)"}}>
            &#x2588;
          </span>
        );
      }
    });
  }
  
  initializeLocationsInfiniteTableData = () => {
    if ((!this.props.memeMotifs) || (this.props.memeMotifs.locations.length === 0) || (this.props.memeMotifs.locations.sites.length === 0))
      return;
    const locations = this.props.memeMotifs.locations;
    const lt = this.state.currentLocationSelection;
    let objs = [];
    let allLocations = 0;
    let motifAndScannedLocations = 0;
    let motifLocations = 0;
    
    locations.sites.forEach((s, si) => {
      let includeSites = false;
      if (lt === "viewAllLocations") {
        includeSites = true;
      }
      if ((lt === "viewMotifLocations") && (s.motif_sites.length > 0)) {
        includeSites = true;
      }
      if ((lt === "viewMotifAndScannedLocations") && ((s.scanned_sites.length > 0) || (s.motif_sites.length > 0))) {
        includeSites = true;
      }
      if (s.motif_sites.length > 0) {
        motifLocations++;
      }
      if ((s.motif_sites.length > 0) || (s.scanned_sites.length > 0)) {
        motifAndScannedLocations++;
      }
      if ((s.motif_sites.length >= 0) || (s.scanned_sites.length >= 0)) {
        allLocations++;
      }
      if (includeSites) {
        //if (si === 0) { console.log("s", JSON.stringify(s, null, 2)); }
        objs.push(
          {
            lt: lt,
            seqIndex: si,
            seqName: s.sequence_name,
            seqPvalue: s.p_value,
            seqObj: s,
            seqLength: s.sequence_length
          }
        )
      }      
    })
    
    const chunkLimit = (this.state.locationsInfiniteTableDataInitialChunk <= objs.length) ? this.state.locationsInfiniteTableDataInitialChunk : objs.length;
    const initialTableData = objs.slice(0, this.state.locationsInfiniteTableDataInitialChunk);
    const initialTableDataOffset = this.state.locationsInfiniteTableDataInitialChunk;
    const initialLocationsInfiniteTableHasMoreData = (chunkLimit < objs.length);
    
    this.setState({
      locationsForLocationSelection: objs,
      locationsInfiniteTableData: initialTableData,
      locationsInfiniteTableDataOffset: initialTableDataOffset,
      locationsInfiniteTableHasMoreData: initialLocationsInfiniteTableHasMoreData,
      locationsAllLocations: allLocations,
      locationsMotifAndScannedLocations: motifAndScannedLocations,
      locationsMotifLocations: motifLocations,
    });
  }
  
  fetchMoreLocationsInfiniteTableData = () => {
    const locationsInfiniteTableData = this.state.locationsInfiniteTableData;
    const oldLocationsInfiniteTableDataOffset = this.state.locationsInfiniteTableDataOffset;
    
    let newLocationsInfiniteTableDataOffset = oldLocationsInfiniteTableDataOffset + this.state.locationsInfiniteTableDataChunk;
    
    const newLocationsInfiniteTableHasMoreData = newLocationsInfiniteTableDataOffset <= this.state.locationsForLocationSelection.length;
    
    if (newLocationsInfiniteTableDataOffset > this.state.locationsForLocationSelection.length) {
      newLocationsInfiniteTableDataOffset = this.state.locationsForLocationSelection.length;
    }
    
    //console.log(`slicing locations from ${oldLocationsInfiniteTableDataOffset} to ${newLocationsInfiniteTableDataOffset}`);
    
    const newLocationsInfiniteTableData = locationsInfiniteTableData.concat(this.state.locationsForLocationSelection.slice(oldLocationsInfiniteTableDataOffset, newLocationsInfiniteTableDataOffset));
    
    setTimeout(() => {
      this.setState({
        locationsInfiniteTableData: newLocationsInfiniteTableData,
        locationsInfiniteTableDataOffset: newLocationsInfiniteTableDataOffset,
        locationsInfiniteTableHasMoreData: newLocationsInfiniteTableHasMoreData
      });
    }, 500);
  }
  
  resetLocationsInfiniteTableData = () => {
    //console.log("resetLocationsInfiniteTableData");
    if (this.state.locationsInfiniteTableDataOffset > this.state.locationsInfiniteTableDataInitialChunk) {
      console.log("resetLocationsInfiniteTableData > resetting locations...");
      const newLocationsInfiniteTableData = this.state.locationsForLocationSelection.slice(0, this.state.locationsInfiniteTableDataInitialChunk);
      const newLocationsInfiniteTableDataOffset = this.state.locationsInfiniteTableDataInitialChunk;
      const chunkLimit = (this.state.locationsInfiniteTableDataInitialChunk <= this.state.locationsForLocationSelection.length) ? this.state.locationsInfiniteTableDataInitialChunk : this.state.locationsForLocationSelection.length;
      const newLocationsInfiniteTableHasMoreData = (chunkLimit < this.state.locationsForLocationSelection.length);
      this.setState({
        locationsKey: this.state.locationsKey + 1,
        locationsInfiniteTableData: newLocationsInfiniteTableData,
        locationsInfiniteTableDataOffset: newLocationsInfiniteTableDataOffset,
        locationsInfiniteTableHasMoreData: newLocationsInfiniteTableHasMoreData
      });
    }
  }
  
  renderLocationWidget = (lt, s, si, sl, width) => {
    let sequence_length = sl;
    let dims = {
      marksXStart: 20,
      marksXEnd: width,
      svgYStart: 0,
      svgYEnd: ((lt === "viewMotifLocations") || (lt === "viewMotifAndScannedLocations") || (lt === "viewAllLocations")) ? 15 : 30,
      svgYMidpoint: ((lt === "viewMotifLocations") || (lt === "viewMotifAndScannedLocations") || (lt === "viewAllLocations")) ? 7.5 : 15,
    };
    
    const generateRectsFromArray = (arr, keyPrefix, fillColor, strokeColor, strokeWidth) => {
      return arr.map((as, asi) => {
        const position = as.position;
        const strand = as.strand;
        const length = ((keyPrefix === 'motif') ? 
          (as.sites.length) :
          (as.motif_name.length))
        // rescale position from [0, sequence_length] to [marksXStart, marksXEnd]
        const xStart = position * (dims.marksXEnd - dims.marksXStart) / sequence_length + (dims.marksXStart - 1);
        let xEnd = (position + length) * (dims.marksXEnd - dims.marksXStart) / sequence_length + (dims.marksXStart - 1);
        if ((xEnd - xStart) < 1) {
          xEnd = xStart + 1;
        }
        const LightenDarkenColor = 
          (col, amt) => '#' + col.slice(1)
                                 .match(/../g)
                                 .map(x => (x = +`0x${x}` + amt, x < 0 ? 0 : (x > 255 ? 255 : x))
                                   .toString(16)
                                   .padStart(2,0))
                                 .join``;
        if (keyPrefix === 'motif') {
          fillColor = this.state.motifColors[as.motif_idx + this.state.motifColorsOffset];
          //strokeColor = LightenDarkenColor(fillColor, -40);
          strokeColor = "#443d45";
        }
        
        //if (si === 0) { console.log(si, asi, s, keyPrefix, position, strand, length, sequence_length, xStart, xEnd, xEnd - xStart); }
        
        const tooltipHTML = this.siteHTMLEntity(s, si, keyPrefix, asi);
        
/*
        if ((si === 0) && (!tooltipHTML)) {
          console.log(si, JSON.stringify(s, null, 2), keyPrefix, asi);
        }
*/

// ((lt === "viewMotifLocations") || (lt === "viewMotifAndScannedLocations") || (lt === "viewAllLocations"))
          
        return (
          <rect 
            key={`locations-row-location-${lt}-${si}-svg-${keyPrefix}-rect-${position}-${asi}`} 
            x={xStart} 
            y={(strand === "+" ? dims.svgYStart + ((keyPrefix === 'motif') ? ((lt === "viewMotifLocations") ? 0.5 : dims.svgYMidpoint/2) : 0.5) : dims.svgYMidpoint)} 
            width={xEnd - xStart} 
            height={(keyPrefix === 'motif' ? ((lt === "viewMotifLocations") ? dims.svgYMidpoint : dims.svgYMidpoint/2) : dims.svgYMidpoint) - 0.5} 
            fill={fillColor}
            stroke={strokeColor}
            strokeWidth={strokeWidth}
            data-for="location-tooltip"
            data-tip={tooltipHTML}
            //data-tip="placeholder"
            ref={ref => this.locationTooltipRef = ref}
            shapeRendering="crispEdges"
            onMouseEnter ={(e) => {
              ReactTooltip.rebuild();
              //console.log("onMouseEnter", keyPrefix, asi);
              //console.log("tooltipHTML", tooltipHTML);
              ReactTooltip.show(this.locationTooltipRef);
            }}
            onMouseOut={(e) => {
              //console.log("onMouseOut", keyPrefix, asi);
              ReactTooltip.hide(this.locationTooltipRef);
            }}
          />
        );
      })
    }
    
    let motifRectFill = "#a79ea9";
    let motifRectStroke = "#443d45";
    let motifRectStrokeWidth = 1;
    let motifKeyPrefix = "motif";
    let motifRects = generateRectsFromArray(s.motif_sites, motifKeyPrefix, motifRectFill, motifRectStroke, motifRectStrokeWidth);

    if (lt === "viewSelectedMotifLocations") {
      const motifSite = s.motif_sites.filter((site) => site.motif_idx === this.state.currentMotifIdx);
      //if (si === 0) console.log(JSON.stringify(motifSite, null, 2));
      motifRects = generateRectsFromArray(motifSite, 
                                          motifKeyPrefix, 
                                          motifRectFill,
                                          motifRectStroke,
                                          motifRectStrokeWidth);
    }
    
    let scannedRectFill = "#a79ea9";
    let scannedRectStroke = "#443d45";
    let scannedRectStrokeWidth = 1;
    let scannedKeyPrefix = "scanned";
    let scannedRects = generateRectsFromArray(s.scanned_sites, 
                                              scannedKeyPrefix, 
                                              scannedRectFill,
                                              scannedRectStroke,
                                              scannedRectStrokeWidth);
    
    if ((lt === "viewAllLocations") && (s.motif_sites.length === 0) && (s.scanned_sites.length === 0)) {
      return <div>{this.locationSVGEntity(lt, si, dims, [])}</div>
    }
    
    else if (((lt === "viewSelectedMotifLocations") || (lt === "viewMotifLocations")) && (s.motif_sites.length >= 0)) { 
      return <div>{this.locationSVGEntity(lt, si, dims, motifRects)}</div>
    }
    
    else if (((lt === "viewMotifAndScannedLocations") || (lt === "viewAllLocations")) && (s.motif_sites.length >= 0) && (s.scanned_sites.length >= 0)) {
      //const allRects = motifRects.concat(scannedRects);
      //const allRects = motifRects;
      const allRects = scannedRects.concat(motifRects);
      //if (si === 0) { console.log("allRects", allRects); }
      return <div>{this.locationSVGEntity(lt, si, dims, allRects)}</div>
    }
  }
  
  locationsMotifColorKey = () => {
    if (this.props.memeMotifs.items.length === 0) 
      return;
    return (
      <div key="locations-motif-color-key" style={{display:"inline-flex",width:"calc(100vw-60)"}}>
        { this.props.memeMotifs.attributes.map((m, mi) => <div key={`locations-motif-color-key-${mi}`} style={{paddingRight:"20px"}}><span className="locations-motif-color-key-block" style={{fontSize:"0.8em",backgroundColor:this.state.motifColors[mi + this.state.motifColorsOffset]}}>&nbsp;</span> <span style={{position:"relative",top:"3px"}}>Epilogo {mi + 1}</span></div>) }
      </div>
    );
  }
  
  locationsInfiniteTable = () => {
    const locations = this.state.locationsInfiniteTableData;
    if ((!locations) || (locations.length === 0)) {
      return;
    }
    
    const locationsTableWidth = (document.getElementById('motif-table-card')) ? document.getElementById('motif-table-card').offsetWidth - 57 : 0;
    
    const locationsIndexWidth = 60;
    const locationsSequenceIndexWidth = 40;
    const locationsSequenceNameWidth = parseInt(locationsTableWidth/3);
    const locationsPvalueWidth = 80;
    const locationsLocationWidgetWidth = locationsTableWidth - (locationsIndexWidth + locationsSequenceIndexWidth + locationsSequenceNameWidth + locationsPvalueWidth);
    
    const rowStyle = {
      fontSize: '0.7em',
      fontFamily: '"Consolas", "Input Mono", "Monaco", "Menlo", "Courier New", Courier, monospace'
    };
    
    const sitesText = document.createElement("span");
    document.body.appendChild(sitesText);
    sitesText.style.font = '"Consolas", "Input Mono", "Monaco", "Menlo", "Courier New", Courier, monospace';
    sitesText.style.fontSize = "0.7em"; 
    sitesText.style.fontWeight = "300";
    sitesText.style.letterSpacing = "-0.001em";
    sitesText.style.height = 'auto'; 
    sitesText.style.width = 'auto'; 
    sitesText.style.position = 'absolute'; 
    sitesText.style.whiteSpace = 'no-wrap'; 
    sitesText.innerHTML = ReactDOMServer.renderToString(this.formattedMotifName(locations[0].seqName, 0, "spacer", "left", locations[0].seqName.length));
    const rawSitesGlyphWidth = sitesText.clientWidth / locations[0].seqName.length;
    const sitesTextWidth = Math.ceil(sitesText.clientWidth);
    document.body.removeChild(sitesText);
    
    const allowedWidth = parseInt(0.33 * locationsTableWidth);
    const allowedGlyphs = parseInt(allowedWidth * 1.75 / rawSitesGlyphWidth);
    function shortenedSequenceName(seqName) {
      //const seqNameTextLength = rawSitesGlyphWidth * seqName.length;
      //return (seqNameTextLength > allowedWidth) ? seqName.substr(0, allowedGlyphs) + "…" : seqName;
      return (seqName.visualLength() > allowedWidth) ? seqName.substr(0, allowedGlyphs) + "…" : seqName;
    }
    const align = "right";
    
    return (
      <div key={this.state.locationsKey} style={{marginTop:"15px"}}>
        <div id={`lis`} style={{height:"300px",overflow:"auto"}}>
          <InfiniteScroll
            dataLength={locations.length}
            next={() => this.fetchMoreLocationsInfiniteTableData()}
            hasMore={this.state.locationsInfiniteTableHasMoreData}
            loader={<div className="loader">Loading locations...</div>}
            endMessage={<div className="end-message">No more locations</div>}
            className={`locations-body`}
            style={{width:locationsTableWidth}}
            scrollThreshold={1}
            scrollableTarget={`lis`}
            >
            {
              locations.map((l, li) => {
  /*
                if (li === 0) {
                  console.log("l/li", JSON.stringify(l, null, 2));
                }
  */
                const lo = l.seqObj;
                const indexOfChrInSequenceName = l.seqName.indexOf("chr");
                const sequenceWithoutSeqPrefix = l.seqName.substr(indexOfChrInSequenceName);
                return (
                  <div style={rowStyle} key={`locations-${li}`}>
                    <div className="locations-row">
                      <div className="locations-row-cell locations-row-cell-index" style={{width:locationsIndexWidth, verticalAlign:"middle"}}>{li + 1}</div>
                      <div className="locations-row-cell locations-row-cell-sequence_index" style={{width:locationsSequenceIndexWidth, verticalAlign:"middle"}}><Badge color="secondary" style={{top:"-1px"}} pill>{lo.sequence_idx + 1}</Badge></div>
                      <div 
                        className="locations-row-cell locations-row-cell-sequence_name"
                        style={{width:locationsSequenceNameWidth, verticalAlign:"middle"}}
                        onMouseMove ={(e) => {
                        const tooltip = document.getElementById("view-container-tooltip");
                        tooltip.innerHTML = `${sequenceWithoutSeqPrefix}`;
                        tooltip.style.display = "block";
                        const rect = tooltip.getBoundingClientRect();
                        if (align === "left") {
                          tooltip.style.left = e.pageX - 5 - rect.width + 'px';
                          tooltip.style.top = e.pageY - 5 - rect.height + 'px';
                        }
                        else if (align === "right") {
                          tooltip.style.left = e.pageX + 10 + 'px';
                          tooltip.style.top = e.pageY - 5 - rect.height + 'px';              
                        }
                      }}
                      onMouseOut={(e) => {
                        const tooltip = document.getElementById("view-container-tooltip");
                        tooltip.style.display = "none";
                      }}
                        >{shortenedSequenceName(sequenceWithoutSeqPrefix)}</div>
                      <div className="locations-row-cell locations-row-cell-pvalue" style={{width:locationsPvalueWidth, verticalAlign:"middle"}}>{l.seqPvalue}</div>
                      <div className="locations-row-cell locations-row-cell-location" style={{width:locationsLocationWidgetWidth, verticalAlign:"middle"}}>{this.renderLocationWidget(l.lt, lo, li, l.seqLength, locationsLocationWidgetWidth)}</div>
                    </div>
                  </div>
                )
              })
            }
          </InfiniteScroll>
        </div>
      </div>
    )
  }
  
  locationSVGEntity = (lt, si, dims, rects) => {
    //console.log(si, dims);
    const cursor = "pointer";
    return (
      <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width={dims.marksXEnd} height={dims.svgYEnd} id={`locations-row-location-${lt}-${si}-svg`} key={`locations-row-location-${lt}-${si}-svg-key`}>
        <style>
          { `rect { cursor:${cursor} }` }
        </style>
        <g id={`locations-row-location-${lt}-${si}-svg-strand`}>
          <text x="10" y={dims.svgYMidpoint - (((lt === "viewMotifLocations") || (lt === "viewMotifAndScannedLocations") || (lt === "viewAllLocations")) ? -1 : 3)} style={{textAnchor:"middle",fontFamily:"Consolas,\"Input Mono\",Monaco,Menlo,\"Courier New\",Courier,monospace"}}>+</text>
          <text x="10" y={dims.svgYEnd - (((lt === "viewMotifLocations") || (lt === "viewMotifAndScannedLocations") || (lt === "viewAllLocations")) ? -1 : 3)} style={{textAnchor:"middle",fontFamily:"Consolas,\"Input Mono\",Monaco,Menlo,\"Courier New\",Courier,monospace"}}>-</text>
        </g>
        <g id={`locations-row-location-${lt}-${si}-svg-marks`}>
          {rects}
          <line x1={dims.marksXStart} y1={dims.svgYMidpoint} x2={dims.marksXEnd} y2={dims.svgYMidpoint} style={{stroke:"#000000",strokeWidth:"0.75px"}} shapeRendering="crispEdges" />
        </g>
      </svg>
    );
  }
  
  siteHTMLEntity = (s, si, keyPrefix, asi) => {
    let results = "";
    const site = (keyPrefix === "motif") ? s.motif_sites[asi] : s.scanned_sites[asi];
    //if (typeof site === "undefined") console.log("si", si, "asi", asi);
    switch (keyPrefix) {
      
      case "motif":
        const leftFlankElement = this.formattedMotifName(site.left_flank, 0.35, "left_flank", "left", site.left_flank.length);
        const centerElement = this.formattedMotifName(site.sites, 1.0, "center", "left", site.sites.length);
        const rightFlankElement = this.formattedMotifName(site.right_flank, 0.35, "right_flank", "left", site.right_flank);
        const leftFlankHTML = ReactDOMServer.renderToStaticMarkup(leftFlankElement);
        const centerHTML = ReactDOMServer.renderToStaticMarkup(centerElement);
        const rightFlankHTML = ReactDOMServer.renderToStaticMarkup(rightFlankElement);
        
        const seqlogoHTML = this.state.noaxisSeqlogoHTMLs[site.motif_idx];
        //const seqlogoWidth = (this.state.clientWidth) ? parseInt(this.state.clientWidth)/3 : 600;
        const seqlogoWidth = this.state.seqlogoWidth;
        const newSeqlogoWidth = 12 * site.motif_name.length;
        const rescale = newSeqlogoWidth / seqlogoWidth;
        const newSeqlogoScale = `translate(0,0) scale(${rescale} 1)`;
        
        if (!seqlogoHTML) return;
        
/*
        if (asi === 0) {
          console.log("seqlogoWidth", seqlogoWidth);
          console.log("site.motif_name.length", site.motif_name.length, "newSeqlogoWidth", newSeqlogoWidth);
          console.log("rescale", rescale);
        }  
*/      
        
        const rewidthSeqlogoHTML = seqlogoHTML.replace(/(<svg width=")(\d+)(.*)(><g transform=")(translate\(0,0\))(.*)/gm, "$1" + newSeqlogoWidth + "$3" + "$4" + newSeqlogoScale + "$6");
        
        results = `
          <div>
            <div class="location-header">Epilogo site</div>
            <table style="margin:0;padding:0">
              <tbody>
                <tr>
                  <td class="location-row-cell"></td>
                  <td class="location-row-cell">${rewidthSeqlogoHTML}</td>
                  <td class="location-row-cell"></td>
                </tr>
                <tr>
                  <td class="location-row-cell location-row-cell-sites-data location-row-cell-left_flank">${leftFlankHTML}</td>
                  <td class="location-row-cell location-row-cell-sites-data location-row-cell-sites">${centerHTML}</td>
                  <td class="location-row-cell location-row-cell-sites-data location-row-cell-right_flank">${rightFlankHTML}</td>
                </tr>
              </tbody>
            </table>
            <table style="margin-top:15px; margin-bottom:15px">
              <tbody>
                <tr>
                  <td class="location-row-cell location-row-cell-label">Name</td>
                  <td class="location-row-cell location-row-cell-value">Epilogo ${site.motif_idx + 1}</td>
                </tr>
                <tr>
                  <td class="location-row-cell location-row-cell-label"><em>p</em>-value</td>
                  <td class="location-row-cell location-row-cell-value">${site.p_value}</td>
                </tr>
                <tr>
                  <td class="location-row-cell location-row-cell-label">Start</td>
                  <td class="location-row-cell location-row-cell-value">${site.position * Constants.epilogosMemeChromatinStateCallIntervalWidth}</td>
                </tr>
                <tr>
                  <td class="location-row-cell location-row-cell-label">End</td>
                  <td class="location-row-cell location-row-cell-value">${(site.position + site.motif_name.length) * Constants.epilogosMemeChromatinStateCallIntervalWidth}</td>
                </tr>
              </tbody>
            </table>
          </div>`;
        break;
        
      case "scanned":
        const centerScannedElement = this.formattedMotifName(site.motif_name, 1.0, "center", "left", site.motif_name.length);
        const centerScannedHTML = ReactDOMServer.renderToStaticMarkup(centerScannedElement);
        
        const scannedSeqlogoHTML = this.state.noaxisSeqlogoHTMLs[site.motif_idx];
        const scannedSeqlogoWidth = this.state.seqlogoWidth;
        const newScannedSeqlogoWidth = 12 * site.motif_name.length;
        const scannedRescale = newScannedSeqlogoWidth / scannedSeqlogoWidth;
        const newScannedSeqlogoScale = `translate(0,0) scale(${scannedRescale} 1)`;
        
        if (!scannedSeqlogoHTML) return;
        
        const rewidthScannedSeqlogoHTML = scannedSeqlogoHTML.replace(/(<svg width=")(\d+)(.*)(><g transform=")(translate\(0,0\))(.*)/gm, "$1" + newScannedSeqlogoWidth + "$3" + "$4" + newScannedSeqlogoScale + "$6");
        
        results = `
          <div>
            <div class="location-header">Scanned site</div>
            <table style="margin:0;padding:0">
              <tbody>
                <tr>
                  <td class="location-row-cell"></td>
                  <td class="location-row-cell">${rewidthScannedSeqlogoHTML}</td>
                  <td class="location-row-cell"></td>
                </tr>
                <tr>
                  <td class="location-row-cell location-row-cell-sites-data location-row-cell-left_flank"></td>
                  <td class="location-row-cell location-row-cell-sites-data location-row-cell-sites">${centerScannedHTML}</td>
                  <td class="location-row-cell location-row-cell-sites-data location-row-cell-right_flank"></td>
                </tr>
              </tbody>
            </table>
            <table style="margin-top:15px; margin-bottom:15px">
              <tbody>
                <tr>
                  <td class="location-row-cell location-row-cell-label">Motif</td>
                  <td class="location-row-cell location-row-cell-value">Epilogo ${site.motif_idx + 1}</td>
                </tr>
                <tr>
                  <td class="location-row-cell location-row-cell-label"><em>p</em>-value</td>
                  <td class="location-row-cell location-row-cell-value">${site.p_value}</td>
                </tr>
                <tr>
                  <td class="location-row-cell location-row-cell-label">Start</td>
                  <td class="location-row-cell location-row-cell-value">${site.position * Constants.epilogosMemeChromatinStateCallIntervalWidth}</td>
                </tr>
                <tr>
                  <td class="location-row-cell location-row-cell-label">End</td>
                  <td class="location-row-cell location-row-cell-value">${(site.position + site.motif_name.length) * Constants.epilogosMemeChromatinStateCallIntervalWidth}</td>
                </tr>
              </tbody>
            </table>
          </div>`;
        break;
        
      default:
        break;
    }
    return results;
  }
  
  render() {
        
    const self = this;
    
    const openClose = function(val, name) {
      return (val) ? 
        <div onClick={()=>{self.flipOpenClose(name)}} style={{position:"relative", top:"4px", paddingRight:"4px"}}>&#9660;</div> 
        : 
        <div onClick={()=>{self.flipOpenClose(name)}} style={{position:"relative", top:"4px", paddingRight:"4px"}}>&#9654;</div>
    }
    
    const tooltipAllMotifsHTML = `<div class="locations-tooltip-help"><p>These are the epilogo sites predicted by <strong>epilogos Search</strong> and used to build the motif.</p><p>These sites are colored by epilogo (see the legend at the bottom). Hovering the cursor over a site will reveal details about the site. Only sequences that contain a epilogo site are shown.</p></div>`;
    
    const tooltipAllMotifsAndScannedHTML = `<div class="locations-tooltip-help"><p>These are the epilogo sites predicted by <strong>epilogos Search</strong> plus any additional sites detected using a epilogo scanning algorithm. Additional scanned sites might match the epilogo, but were not used to build the epilogo model.</p><p>Epilogo sites are colored by epilogo ID and additional scanned sites are colored in grey. Hovering the cursor over a site will reveal details about the site. Only sequences containing a predicted or scanned epilogo site are shown.</p><p>The scanned sites are predicted using a log-odds scoring matrix constructed from the <strong>epilogos Search</strong> sites. Only scanned sites with position <em>p</em>-values less than 0.0001 are shown.</p></div>`;
    
    const tooltipAllLocationsHTML = `<div class="locations-tooltip-help"><p>These are the same sites as shown by selecting the "All Epilogos + Scanned" sites button except that all sequences, including those with no sites, are included in the diagram.</p></div>`;
    
    return (
      <div id="viewer-container-no-margin" className="viewer-container-no-margin" ref="viewerContainer" key={this.state.viewerContainerKey}>
      
        <Modal isOpen={this.state.fimoQueryModalIsOpen} toggle={this.fimoQueryModalToggle}>
          <ModalHeader toggle={this.fimoQueryModalToggle}>Advanced Search</ModalHeader>
          <ModalBody>
            { this.fimoQueryModalTable() }
          </ModalBody>
          <ModalFooter>
            <Button 
              className="btn-epilogos"
              color="primary" 
              disabled={!this.fimoQueryModalDataIsValid()} 
              onClick={this.fimoQueryTrigger}>
              Search
            </Button>
            {' '}
            <Button 
              className="btn-epilogos-secondary"
              color="secondary" 
              onClick={this.fimoQueryModalToggle}>
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
        
        <Modal isOpen={this.state.fimoQueryMotifDataModalIsOpen} toggle={this.fimoQueryMotifDataModalToggle} style={{maxWidth:"max-content"}}>
          <ModalHeader toggle={this.fimoQueryMotifDataModalToggle}>Hits for <strong>Epilogo {(parseInt(this.state.fimoQueryMotifDataIdx) + 1)}</strong></ModalHeader>
          <ModalBody>
            { this.fimoQueryMotifDataTable() }
          </ModalBody>
          <ModalFooter>
            <Button 
              color="secondary" 
              onClick={this.fimoQueryMotifDataModalToggle}>
              Close
            </Button>
          </ModalFooter>
        </Modal>
      
        <ReactTooltip 
          id="location-tooltip" 
          className="location-tooltip" 
          delayHide={100} 
          type="dark" 
          effect="solid" 
          html={true} />
      
        <div id="view-container-tooltip" className="view-container-tooltip" style={{position:"absolute", display:"none", zIndex:"1000001"}} />
        
        <div>{((this.props.dataState === "valid") && (this.props.memeJSON)) ? 
          
          <div className={this.props.archiveURL === "" ? 'hidden' : ''}>
          
            <div style={{paddingLeft:"15px", paddingTop:"10px"}}>
              <span style={{fontSize:"0.9em", fontWeight:"400"}}><FaHome className="brand-content-text-viewer-home" onClick={(e)=>{window.location=Constants.epilogosMemeURL}} /> <span style={{cursor:"pointer"}} onClick={(e)=>{window.location=Constants.epilogosMemeURL}}>epilogos Search</span></span><br />
              <span style={{fontSize:"1.5em", fontWeight:"600"}}>{this.props.description.replace(/_/g, ' ')}</span>
            </div>
            
            {(this.props.memeDataAvailable) ? 
              
              <div>
                
                <div style={{paddingLeft:"15px", marginTop:"25px"}}>
                  <span onClick={()=>{this.jumpToAnchor('analysisSummary')}} style={{cursor:"pointer", textDecoration:"underline", color:"#173365"}}>Analysis summary</span> | <span onClick={()=>{this.jumpToAnchor('epilogos')}} style={{cursor:"pointer", textDecoration:"underline", color:"#173365"}}>Discovered epilogos</span> | <span style={{display:(this.state.visible.motifLocations ? "inline-block" : "none")}}><span onClick={()=>{this.jumpToAnchor('epilogosLocations')}} style={{cursor:"pointer", textDecoration:"underline", color:"#173365"}}>Epilogos in context</span> |</span> <span onClick={()=>{this.jumpToAnchor('downloads')}} style={{cursor:"pointer", textDecoration:"underline", color:"#173365"}}>Downloads</span>
                </div>
                
                <div style={{marginTop:"25px"}}>
                  <h3 ref='analysisSummary' style={{fontSize:"larger", display:"flex"}}>
                    <span className="hide-show">{openClose(this.state.openClose.jobSummary, "jobSummary")} </span>
                    Analysis summary
                  </h3>
                  <Collapse isOpen={this.state.openClose.jobSummary} style={{paddingLeft:"15px"}}>
                    <Card id="analysisSummary-table-card">
                      <CardBody>
                        <CardText tag="div">
                          { this.jobSummary() }
                        </CardText>
                      </CardBody>
                    </Card>
                  </Collapse>
                </div>
                
                <div style={{marginTop:"25px"}}>
                  <h3 ref='epilogos' style={{fontSize:"larger", display:"flex"}}>
                    <span className="hide-show">{openClose(this.state.openClose.discoveredMotifs, "discoveredMotifs")} </span>
                    Discovered epilogos
                  </h3>
                  <Collapse isOpen={this.state.openClose.discoveredMotifs} style={{paddingLeft:"15px"}}>
                    <Card id="motif-table-card">
                      <CardBody>
                        <CardText tag="div">
                          { this.motifTable() }
                        </CardText>
                      </CardBody>
                    </Card>
                  </Collapse>
                </div>
                
                <div style={{marginTop:"20px",display:(this.state.visible.motifLocations ? "inline-block" : "none")}}>
                  <h3 ref='epilogosLocations' style={{fontSize:"larger", display:"flex"}}>
                    <span className="hide-show">{openClose(this.state.openClose.motifLocations, "motifLocations")} </span>
                    Epilogos in context
                  </h3>
                  <Collapse isOpen={this.state.openClose.motifLocations}>
                    <Card id="locations-table-card">
                      <CardBody>
                        <CardText tag="div">
                        
                          <div style={{}}>
                          
                            {/* 
                            <h3 style={{fontSize:"larger", display:"flex"}}>
                              <span className="hide-show">{openClose(this.state.openClose.motifLocationSites, "motifLocationSites")} </span>
                              Sites
                            </h3>
                            */}
                            
                            {/* <Collapse isOpen={this.state.openClose.motifLocationSites} style={{paddingLeft:"15px"}}> */}
                            
                              {/*
                              <div style={{display:"inline-block", marginTop:"5px"}}>
                                
                                <div style={{display:"inline-block", paddingLeft:"20px"}} className="location-selector" data-name="viewMotifLocations" onClick={(e)=>{this.handleLocationsClick("viewMotifLocations")}}>{(this.state.currentLocationSelection === "viewMotifLocations") ? <FaRegDotCircle className="fa-accessible-icon" /> : <FaRegCircle className="fa-accessible-icon" />} <span style={{position:"relative", top:"2px"}} data-for="location-tooltip" data-tip={tooltipAllMotifsHTML} ref={ref => this.locationTooltipRef = ref} onMouseEnter ={(e) => { ReactTooltip.rebuild(); ReactTooltip.show(this.locationTooltipRef); }} onMouseOut={(e) => { ReactTooltip.hide(this.locationTooltipRef); }}>All Epilogos ({this.state.locationsMotifLocations} sites)</span></div>
                                
                                
                                <div style={{display:"inline-block", paddingLeft:"20px"}} className="location-selector" data-name="viewMotifAndScannedLocations" onClick={(e)=>{this.handleLocationsClick("viewMotifAndScannedLocations")}}>{(this.state.currentLocationSelection === "viewMotifAndScannedLocations") ? <FaRegDotCircle className="fa-accessible-icon" /> : <FaRegCircle className="fa-accessible-icon" />} <span style={{position:"relative", top:"2px"}} data-for="location-tooltip" data-tip={tooltipAllMotifsAndScannedHTML} ref={ref => this.locationTooltipRef = ref} onMouseEnter ={(e) => { ReactTooltip.rebuild(); ReactTooltip.show(this.locationTooltipRef); }} onMouseOut={(e) => { ReactTooltip.hide(this.locationTooltipRef); }}>All Epilogos + Scanned ({this.state.locationsMotifAndScannedLocations})</span></div>
                                
                                <div style={{display:"inline-block", paddingLeft:"20px"}} className="location-selector" data-name="viewAllLocations" onClick={(e)=>{this.handleLocationsClick("viewAllLocations")}}>{(this.state.currentLocationSelection === "viewAllLocations") ? <FaRegDotCircle className="fa-accessible-icon" height={"16px"} width={"16px"} /> : <FaRegCircle className="fa-accessible-icon" />} <span style={{position:"relative", top:"2px"}} data-for="location-tooltip" data-tip={tooltipAllLocationsHTML} ref={ref => this.locationTooltipRef = ref} onMouseEnter ={(e) => { ReactTooltip.rebuild(); ReactTooltip.show(this.locationTooltipRef); }} onMouseOut={(e) => { ReactTooltip.hide(this.locationTooltipRef); }}>All Locations ({this.state.locationsAllLocations})</span></div>
                                  
                              </div>
                              */}
                              
                              <div style={{display:"block", textAlign:"center", marginBottom:"15px", paddingBottom:"10px", borderBottom:"1px dotted grey"}}>
                                <div style={{width:"85%", margin:"auto"}}>
                                  These are the locations predicted by <strong>epilogos Search</strong> and used to build the epilogo model. Hovering the cursor over a site reveals details about its chromatin states in context of the larger sequence. Only sequences that contain a epilogo site are shown.
                                </div>
                              </div>
                              
                              <div>
                                { this.locationsInfiniteTable() }
                              </div>
                              
                              <div style={{display:"block", textAlign:"center", marginTop:"15px", paddingTop:"10px", borderTop:"1px dotted grey"}}> 
                                { this.locationsMotifColorKey() }
                              </div>
                                                          
                            {/* </Collapse> */}

                          </div>
                          
                        </CardText>
                      </CardBody>
                    </Card>
                  </Collapse>
                </div>
                
                <div style={{marginTop:"25px", marginBottom:"25px"}}>
                  <h3 ref="downloads" style={{fontSize:"larger", display:"flex"}}>
                    <span className="hide-show">{openClose(this.state.openClose.downloads, "downloads")} </span>
                    Downloads
                  </h3>
                  <Collapse isOpen={this.state.openClose.downloads} style={{paddingLeft:"15px"}}>
                    <Card>
                      <CardBody>
                        <CardText tag="div">
                          
                          <div style={{}}>
                            <h3 style={{fontSize:"larger", display:"flex"}}>
                              <span className="hide-show">{openClose(this.state.openClose.epilogosMEMEDownloads, "epilogosMEMEDownloads")} </span>
                              Epilogos Search
                            </h3>
                            <Collapse isOpen={this.state.openClose.epilogosMEMEDownloads} style={{paddingLeft:"15px"}}>
                              <form className="navbar-form navbar-right" role="button" style={{marginBottom:"15px"}}>
                                <Button 
                                  size="sm"
                                  className="btn-download btn-epilogos" 
                                  color="primary" 
                                  name="downloadResults" 
                                  ref={(thisButton) => {this.downloadResultsButton = thisButton}} 
                                  onClick={this.handleClick} >
                                  <FaDownload /> Summary (bz2)
                                </Button>
                                <Button 
                                  size="sm"
                                  style={{marginLeft:"10px"}}
                                  className="btn-download btn-epilogos" 
                                  color="primary" 
                                  name="downloadJSONEpilogosMEME" 
                                  ref={(thisButton) => {this.downloadJSONButton = thisButton}} 
                                  onClick={this.handleClick} >
                                  <FaDownload /> JSON
                                </Button>
                              </form>
                            </Collapse>
                          </div>
                          
                          <div style={{marginTop:"30px"}}>
                            <h3 style={{fontSize:"larger", display:"flex"}}>
                              <span className="hide-show">{openClose(this.state.openClose.analysisDownloads, "analysisDownloads")} </span>
                              Analysis
                            </h3>
                            <Collapse isOpen={this.state.openClose.analysisDownloads} style={{paddingLeft:"15px"}}>
                              <form className="navbar-form navbar-right" role="button" style={{marginBottom:"15px"}}>
                                <Button 
                                  size="sm"
                                  style={{}}
                                  className="btn-download btn-epilogos" 
                                  color="primary" 
                                  name="downloadJSONAnalysis" 
                                  ref={(thisButton) => {this.downloadJSONButton = thisButton}} 
                                  onClick={this.handleClick} >
                                  <FaDownload /> JSON
                                </Button>
                              </form>
                            </Collapse>
                          </div>
                          
                        </CardText>
                      </CardBody>
                    </Card>
                    
                  </Collapse>
                </div>
                
                <span id="ruler"></span>
                
              </div>
              
            :
            
              this.reportNotReady()
                            
            }
            
          </div>
          
          :
          
            this.reportNotReady()

        }
        </div>
      </div>
    );
  }
}

export default ViewPanelV3;